import { DateTime } from 'luxon';
import { getCurrentTimeInUTC } from '../../../shared/components/date-filter/date-filter-options';

export const DEPARTMENT_DATA = [
  { key: "General Management", value: "General Management" },
  { key: "Engineering and Technical", value: "Engineering and Technical" },
  { key: "Operations", value: "Operations" },
  { key: "Sales", value: "Sales" },
  { key: "Finance & Accounting", value: "Finance & Accounting" },
  { key: "Education", value: "Education" },
  { key: "Medical", value: "Medical" },
  { key: "Administrative", value: "Administrative" },
  { key: "Consulting", value: "Consulting" },
  { key: "Project Management", value: "Project Management" },
  { key: "Marketing", value: "Marketing" },
  { key: "Customer Service", value: "Customer Service" },
  { key: "Trades", value: "Trades" },
  { key: "Human Resources", value: "Human Resources" },
  { key: "Design", value: "Design" },
  { key: "Research", value: "Research" },
  { key: "Legal", value: "Legal" },
  { key: "Real Estate", value: "Real Estate" },
  { key: "Product", value: "Product" },
  { key: "Other", value: "Other" }
];

export const LOCATION_DATA = [
  {
    key: 'Northern America',
    value: 'Northern America',
    children: [
      {
        key: 'Canada',
        value: 'Canada',
        emoji: '🇨🇦',
      },
      {
        key: 'Saint Pierre and Miquelon',
        value: 'Saint Pierre and Miquelon',
        emoji: '🇵🇲',
      },
      {
        key: 'United States',
        value: 'United States',
        emoji: '🇺🇸',
      },
      {
        key: 'U.S. Outlying Islands',
        value: 'U.S. Outlying Islands',
      },
    ],
  },
  {
    key: 'Latin America and the Caribbean',
    value: 'Latin America and the Caribbean',
    children: [
      {
        key: 'Antigua and Barbuda',
        value: 'Antigua and Barbuda',
        emoji: '🇦🇬',
      },
      {
        key: 'Argentina',
        value: 'Argentina',
        emoji: '🇦🇷',
      },
      {
        key: 'Barbados',
        value: 'Barbados',
        emoji: '🇧🇧',
      },
      {
        key: 'Belize',
        value: 'Belize',
        emoji: '🇧🇿',
      },
      {
        key: 'Bolivia',
        value: 'Bolivia',
        emoji: '🇧🇴',
      },
      {
        key: 'Bonaire, Sint Eustatius, and Saba',
        value: 'Bonaire, Sint Eustatius, and Saba',
      },
      {
        key: 'Brazil',
        value: 'Brazil',
        emoji: '🇧🇷',
      },
      {
        key: 'Chile',
        value: 'Chile',
        emoji: '🇨🇱',
      },
      {
        key: 'Colombia',
        value: 'Colombia',
        emoji: '🇨🇴',
      },
      {
        key: 'Costa Rica',
        value: 'Costa Rica',
        emoji: '🇨🇷',
      },
      {
        key: 'Cuba',
        value: 'Cuba',
        emoji: '🇨🇺',
      },
      {
        key: 'Dominica',
        value: 'Dominica',
        emoji: '🇩🇲',
      },
      {
        key: 'Dominican Republic',
        value: 'Dominican Republic',
        emoji: '🇩🇴',
      },
      {
        key: 'Ecuador',
        value: 'Ecuador',
        emoji: '🇪🇨',
      },
      {
        key: 'El Salvador',
        value: 'El Salvador',
        emoji: '🇸🇻',
      },
      {
        key: 'Grenada',
        value: 'Grenada',
        emoji: '🇬🇩',
      },
      {
        key: 'Guatemala',
        value: 'Guatemala',
        emoji: '🇬🇹',
      },
      {
        key: 'Haiti',
        value: 'Haiti',
        emoji: '🇭🇹',
      },
      {
        key: 'Jamaica',
        value: 'Jamaica',
        emoji: '🇯🇲',
      },
      {
        key: 'Mexico',
        value: 'Mexico',
        emoji: '🇲🇽',
      },
      {
        key: 'Nicaragua',
        value: 'Nicaragua',
        emoji: '🇳🇮',
      },
      {
        key: 'Panama',
        value: 'Panama',
        emoji: '🇵🇦',
      },
      {
        key: 'Paraguay',
        value: 'Paraguay',
        emoji: '🇵🇾',
      },
      {
        key: 'Peru',
        value: 'Peru',
        emoji: '🇵🇪',
      },
      {
        key: 'Saint Kitts and Nevis',
        value: 'Saint Kitts and Nevis',
        emoji: '🇰🇳',
      },
      {
        key: 'Saint Lucia',
        value: 'Saint Lucia',
        emoji: '🇱🇨',
      },
      {
        key: 'Saint Vincent and the Grenadines',
        value: 'Saint Vincent and the Grenadines',
        emoji: '🇻🇨',
      },
      {
        key: 'Suriname',
        value: 'Suriname',
        emoji: '🇸🇷',
      },
      {
        key: 'Trinidad and Tobago',
        value: 'Trinidad and Tobago',
        emoji: '🇹🇹',
      },
      {
        key: 'Uruguay',
        value: 'Uruguay',
        emoji: '🇺🇾',
      },
      {
        key: 'Venezuela',
        value: 'Venezuela',
        emoji: '🇻🇪',
      },
    ],
  },
  {
    key: 'Central America',
    value: 'Central America',
    children: [
      {
        key: 'Belize',
        value: 'Belize',
        emoji: '🇧🇿',
      },
      {
        key: 'Costa Rica',
        value: 'Costa Rica',
        emoji: '🇨🇷',
      },
      {
        key: 'El Salvador',
        value: 'El Salvador',
        emoji: '🇸🇻',
      },
      {
        key: 'Guatemala',
        value: 'Guatemala',
        emoji: '🇬🇹',
      },
      {
        key: 'Honduras',
        value: 'Honduras',
        emoji: '🇭🇳',
      },
      {
        key: 'Nicaragua',
        value: 'Nicaragua',
        emoji: '🇳🇮',
      },
      {
        key: 'Panama',
        value: 'Panama',
        emoji: '🇵🇦',
      },
    ],
  },
  {
    key: 'South America',
    value: 'South America',
    children: [
      {
        key: 'Argentina',
        value: 'Argentina',
        emoji: '🇦🇷',
      },
      {
        key: 'Bolivia',
        value: 'Bolivia',
        emoji: '🇧🇴',
      },
      {
        key: 'Brazil',
        value: 'Brazil',
        emoji: '🇧🇷',
      },
      {
        key: 'Chile',
        value: 'Chile',
        emoji: '🇨🇱',
      },
      {
        key: 'Colombia',
        value: 'Colombia',
        emoji: '🇨🇴',
      },
      {
        key: 'Guyana',
        value: 'Guyana',
        emoji: '🇬🇾',
      },
      {
        key: 'Paraguay',
        value: 'Paraguay',
        emoji: '🇵🇾',
      },
      {
        key: 'Peru',
        value: 'Peru',
        emoji: '🇵🇪',
      },
      {
        key: 'Suriname',
        value: 'Suriname',
        emoji: '🇸🇷',
      },
      {
        key: 'Uruguay',
        value: 'Uruguay',
        emoji: '🇺🇾',
      },
      {
        key: 'Venezuela',
        value: 'Venezuela',
        emoji: '🇻🇪',
      },
    ],
  },
  {
    key: 'Asia',
    value: 'Asia',
    children: [
      {
        key: 'Afghanistan',
        value: 'Afghanistan',
        emoji: '🇦🇫',
      },
      {
        key: 'Armenia',
        value: 'Armenia',
        emoji: '🇦🇲',
      },
      {
        key: 'Azerbaijan',
        value: 'Azerbaijan',
        emoji: '🇦🇿',
      },
      {
        key: 'Bahrain',
        value: 'Bahrain',
        emoji: '🇧🇭',
      },
      {
        key: 'Bangladesh',
        value: 'Bangladesh',
        emoji: '🇧🇩',
      },
      {
        key: 'Bhutan',
        value: 'Bhutan',
        emoji: '🇧🇹',
      },
      {
        key: 'China',
        value: 'China',
        emoji: '🇨🇳',
      },
      {
        key: 'India',
        value: 'India',
        emoji: '🇮🇳',
      },
      {
        key: 'Indonesia',
        value: 'Indonesia',
        emoji: '🇮🇩',
      },
      {
        key: 'Iran',
        value: 'Iran',
        emoji: '🇮🇷',
      },
      {
        key: 'Iraq',
        value: 'Iraq',
        emoji: '🇮🇶',
      },
      {
        key: 'Israel',
        value: 'Israel',
        emoji: '🇮🇱',
      },
      {
        key: 'Japan',
        value: 'Japan',
        emoji: '🇯🇵',
      },
      {
        key: 'Jordan',
        value: 'Jordan',
        emoji: '🇯🇴',
      },
      {
        key: 'Kazakhstan',
        value: 'Kazakhstan',
        emoji: '🇰🇿',
      },
      {
        key: 'Kuwait',
        value: 'Kuwait',
        emoji: '🇰🇼',
      },
      {
        key: 'Kyrgyzstan',
        value: 'Kyrgyzstan',
        emoji: '🇰🇬',
      },
      {
        key: 'Lebanon',
        value: 'Lebanon',
        emoji: '🇱🇧',
      },
      {
        key: 'Malaysia',
        value: 'Malaysia',
        emoji: '🇲🇾',
      },
      {
        key: 'Maldives',
        value: 'Maldives',
        emoji: '🇲🇻',
      },
      {
        key: 'Myanmar',
        value: 'Myanmar',
        emoji: '🇲🇲',
      },
      {
        key: 'Nepal',
        value: 'Nepal',
        emoji: '🇳🇵',
      },
      {
        key: 'North Korea',
        value: 'North Korea',
        emoji: '🇰🇵',
      },
      {
        key: 'Pakistan',
        value: 'Pakistan',
        emoji: '🇵🇰',
      },
      {
        key: 'Palestine State',
        value: 'Palestine State',
      },
      {
        key: 'Philippines',
        value: 'Philippines',
        emoji: '🇵🇭',
      },
      {
        key: 'Qatar',
        value: 'Qatar',
        emoji: '🇶🇦',
      },
      {
        key: 'Saudi Arabia',
        value: 'Saudi Arabia',
        emoji: '🇸🇦',
      },
      {
        key: 'Singapore',
        value: 'Singapore',
        emoji: '🇸🇬',
      },
      {
        key: 'South Korea',
        value: 'South Korea',
        emoji: '🇰🇷',
      },
      {
        key: 'Sri Lanka',
        value: 'Sri Lanka',
        emoji: '🇱🇰',
      },
      {
        key: 'Syria',
        value: 'Syria',
        emoji: '🇸🇾',
      },
      {
        key: 'Taiwan',
        value: 'Taiwan',
        emoji: '🇹🇼',
      },
      {
        key: 'Tajikistan',
        value: 'Tajikistan',
        emoji: '🇹🇯',
      },
      {
        key: 'Thailand',
        value: 'Thailand',
        emoji: '🇹🇭',
      },
      {
        key: 'Timor-Leste',
        value: 'Timor-Leste',
        emoji: '🇹🇱',
      },
      {
        key: 'Turkey',
        value: 'Turkey',
        emoji: '🇹🇷',
      },
      {
        key: 'Turkmenistan',
        value: 'Turkmenistan',
        emoji: '🇹🇲',
      },
      {
        key: 'United Arab Emirates',
        value: 'United Arab Emirates',
        emoji: '🇦🇪',
      },
      {
        key: 'Vietnam',
        value: 'Vietnam',
        emoji: '🇻🇳',
      },
      {
        key: 'Yemen',
        value: 'Yemen',
        emoji: '🇾🇪',
      },
    ],
  },
  {
    key: 'Southern Asia',
    value: 'Southern Asia',
    children: [
      {
        key: 'Afghanistan',
        value: 'Afghanistan',
        emoji: '🇦🇫',
      },
      {
        key: 'Bangladesh',
        value: 'Bangladesh',
        emoji: '🇧🇩',
      },
      {
        key: 'Bhutan',
        value: 'Bhutan',
        emoji: '🇧🇹',
      },
      {
        key: 'India',
        value: 'India',
        emoji: '🇮🇳',
      },
      {
        key: 'Iran',
        value: 'Iran',
        emoji: '🇮🇷',
      },
      {
        key: 'Maldives',
        value: 'Maldives',
        emoji: '🇲🇻',
      },
      {
        key: 'Nepal',
        value: 'Nepal',
        emoji: '🇳🇵',
      },
      {
        key: 'Pakistan',
        value: 'Pakistan',
        emoji: '🇵🇰',
      },
      {
        key: 'Sri Lanka',
        value: 'Sri Lanka',
        emoji: '🇱🇰',
      },
    ],
  },
  {
    key: 'South-Eastern Asia',
    value: 'South-Eastern Asia',
    children: [
      {
        key: 'Brunei',
        value: 'Brunei',
        emoji: '🇧🇳',
      },
      {
        key: 'Cambodia',
        value: 'Cambodia',
        emoji: '🇰🇭',
      },
      {
        key: 'Indonesia',
        value: 'Indonesia',
        emoji: '🇮🇩',
      },
      {
        key: 'Laos',
        value: 'Laos',
        emoji: '🇱🇦',
      },
      {
        key: 'Malaysia',
        value: 'Malaysia',
        emoji: '🇲🇾',
      },
      {
        key: 'Myanmar',
        value: 'Myanmar',
        emoji: '🇲🇲',
      },
      {
        key: 'Philippines',
        value: 'Philippines',
        emoji: '🇵🇭',
      },
      {
        key: 'Singapore',
        value: 'Singapore',
        emoji: '🇸🇬',
      },
      {
        key: 'Thailand',
        value: 'Thailand',
        emoji: '🇹🇭',
      },
      {
        key: 'Timor-Leste',
        value: 'Timor-Leste',
        emoji: '🇹🇱',
      },
      {
        key: 'Vietnam',
        value: 'Vietnam',
        emoji: '🇻🇳',
      },
    ],
  },
  {
    key: 'Western Asia',
    value: 'Western Asia',
    children: [
      {
        key: 'Armenia',
        value: 'Armenia',
        emoji: '🇦🇲',
      },
      {
        key: 'Azerbaijan',
        value: 'Azerbaijan',
        emoji: '🇦🇿',
      },
      {
        key: 'Bahrain',
        value: 'Bahrain',
        emoji: '🇧🇭',
      },
      {
        key: 'Iraq',
        value: 'Iraq',
        emoji: '🇮🇶',
      },
      {
        key: 'Israel',
        value: 'Israel',
        emoji: '🇮🇱',
      },
      {
        key: 'Jordan',
        value: 'Jordan',
        emoji: '🇯🇴',
      },
      {
        key: 'Kuwait',
        value: 'Kuwait',
        emoji: '🇰🇼',
      },
      {
        key: 'Lebanon',
        value: 'Lebanon',
        emoji: '🇱🇧',
      },
      {
        key: 'Oman',
        value: 'Oman',
        emoji: '🇴🇲',
      },
      {
        key: 'Palestine State',
        value: 'Palestine State',
      },
      {
        key: 'Qatar',
        value: 'Qatar',
        emoji: '🇶🇦',
      },
      {
        key: 'Saudi Arabia',
        value: 'Saudi Arabia',
        emoji: '🇸🇦',
      },
      {
        key: 'Syria',
        value: 'Syria',
        emoji: '🇸🇾',
      },
      {
        key: 'Turkey',
        value: 'Turkey',
        emoji: '🇹🇷',
      },
      {
        key: 'Yemen',
        value: 'Yemen',
        emoji: '🇾🇪',
      },
    ],
  },
  {
    key: 'Eastern Asia',
    value: 'Eastern Asia',
    children: [
      {
        key: 'China',
        value: 'China',
        emoji: '🇨🇳',
      },
      {
        key: 'Hong Kong',
        value: 'Hong Kong',
      },
      {
        key: 'Japan',
        value: 'Japan',
        emoji: '🇯🇵',
      },
      {
        key: 'Mongolia',
        value: 'Mongolia',
        emoji: '🇲🇳',
      },
      {
        key: 'North Korea',
        value: 'North Korea',
        emoji: '🇰🇵',
      },
      {
        key: 'South Korea',
        value: 'South Korea',
        emoji: '🇰🇷',
      },
      {
        key: 'Taiwan',
        value: 'Taiwan',
        emoji: '🇹🇼',
      },
    ],
  },
  {
    key: 'EMEA',
    value: 'EMEA',
    children: [
      {
        key: 'Afghanistan',
        value: 'Afghanistan',
        emoji: '🇦🇫',
      },
      {
        key: 'Albania',
        value: 'Albania',
        emoji: '🇦🇱',
      },
      {
        key: 'Algeria',
        value: 'Algeria',
        emoji: '🇩🇿',
      },
      {
        key: 'Andorra',
        value: 'Andorra',
        emoji: '🇦🇩',
      },
      {
        key: 'Angola',
        value: 'Angola',
        emoji: '🇦🇴',
      },
      {
        key: 'Armenia',
        value: 'Armenia',
        emoji: '🇦🇲',
      },
      {
        key: 'Australia',
        value: 'Australia',
        emoji: '🇦🇺',
      },
      {
        key: 'Austria',
        value: 'Austria',
        emoji: '🇦🇹',
      },
      {
        key: 'Azerbaijan',
        value: 'Azerbaijan',
        emoji: '🇦🇿',
      },
      {
        key: 'Bahrain',
        value: 'Bahrain',
        emoji: '🇧🇭',
      },
      {
        key: 'Bangladesh',
        value: 'Bangladesh',
        emoji: '🇧🇩',
      },
      {
        key: 'Belarus',
        value: 'Belarus',
        emoji: '🇧🇾',
      },
      {
        key: 'Belgium',
        value: 'Belgium',
        emoji: '🇧🇪',
      },
      {
        key: 'Benin',
        value: 'Benin',
        emoji: '🇧🇯',
      },
      {
        key: 'Bhutan',
        value: 'Bhutan',
        emoji: '🇧🇹',
      },
      {
        key: 'Bosnia and Herzegovina',
        value: 'Bosnia and Herzegovina',
        emoji: '🇧🇦',
      },
      {
        key: 'Botswana',
        value: 'Botswana',
        emoji: '🇧🇼',
      },
      {
        key: 'Bulgaria',
        value: 'Bulgaria',
        emoji: '🇧🇬',
      },
      {
        key: 'Burkina Faso',
        value: 'Burkina Faso',
        emoji: '🇧🇫',
      },
      {
        key: 'Burundi',
        value: 'Burundi',
        emoji: '🇧🇮',
      },
      {
        key: 'Cabo Verde',
        value: 'Cabo Verde',
      },
      {
        key: 'Cameroon',
        value: 'Cameroon',
        emoji: '🇨🇲',
      },
      {
        key: 'Czechia',
        value: 'Czechia',
      },
      {
        key: 'Cyprus',
        value: 'Cyprus',
        emoji: '🇨🇾',
      },
      {
        key: 'Democratic Republic of the Congo',
        value: 'Democratic Republic of the Congo',
        emoji: '🇨🇩',
      },
      {
        key: 'Denmark',
        value: 'Denmark',
        emoji: '🇩🇰',
      },
      {
        key: 'Djibouti',
        value: 'Djibouti',
        emoji: '🇩🇯',
      },
      {
        key: 'Egypt',
        value: 'Egypt',
        emoji: '🇪🇬',
      },
      {
        key: 'Estonia',
        value: 'Estonia',
        emoji: '🇪🇪',
      },
      {
        key: 'Eswatini',
        value: 'Eswatini',
        emoji: '🇸🇿',
      },
      {
        key: 'Ethiopia',
        value: 'Ethiopia',
        emoji: '🇪🇹',
      },
      {
        key: 'Finland',
        value: 'Finland',
        emoji: '🇫🇮',
      },
      {
        key: 'France',
        value: 'France',
        emoji: '🇫🇷',
      },
      {
        key: 'Gabon',
        value: 'Gabon',
        emoji: '🇬🇦',
      },
      {
        key: 'Gambia',
        value: 'Gambia',
      },
      {
        key: 'Georgia',
        value: 'Georgia',
        emoji: '🇬🇪',
      },
      {
        key: 'Germany',
        value: 'Germany',
        emoji: '🇩🇪',
      },
      {
        key: 'Ghana',
        value: 'Ghana',
        emoji: '🇬🇭',
      },
      {
        key: 'Greece',
        value: 'Greece',
        emoji: '🇬🇷',
      },
      {
        key: 'Hungary',
        value: 'Hungary',
        emoji: '🇭🇺',
      },
      {
        key: 'Iceland',
        value: 'Iceland',
        emoji: '🇮🇸',
      },
      {
        key: 'Ireland',
        value: 'Ireland',
        emoji: '🇮🇪',
      },
      {
        key: 'Israel',
        value: 'Israel',
        emoji: '🇮🇱',
      },
      {
        key: 'Italy',
        value: 'Italy',
        emoji: '🇮🇹',
      },
      {
        key: 'Kazakhstan',
        value: 'Kazakhstan',
        emoji: '🇰🇿',
      },
      {
        key: 'Kuwait',
        value: 'Kuwait',
        emoji: '🇰🇼',
      },
      {
        key: 'Latvia',
        value: 'Latvia',
        emoji: '🇱🇻',
      },
      {
        key: 'Lebanon',
        value: 'Lebanon',
        emoji: '🇱🇧',
      },
      {
        key: 'Lesotho',
        value: 'Lesotho',
        emoji: '🇱🇸',
      },
      {
        key: 'Liberia',
        value: 'Liberia',
        emoji: '🇱🇷',
      },
      {
        key: 'Libya',
        value: 'Libya',
        emoji: '🇱🇾',
      },
      {
        key: 'Liechtenstein',
        value: 'Liechtenstein',
        emoji: '🇱🇮',
      },
      {
        key: 'Lithuania',
        value: 'Lithuania',
        emoji: '🇱🇹',
      },
      {
        key: 'Luxembourg',
        value: 'Luxembourg',
        emoji: '🇱🇺',
      },
      {
        key: 'Malawi',
        value: 'Malawi',
        emoji: '🇲🇼',
      },
      {
        key: 'Mauritania',
        value: 'Mauritania',
        emoji: '🇲🇷',
      },
      {
        key: 'Mauritius',
        value: 'Mauritius',
        emoji: '🇲🇺',
      },
      {
        key: 'Morocco',
        value: 'Morocco',
        emoji: '🇲🇦',
      },
      {
        key: 'Mozambique',
        value: 'Mozambique',
        emoji: '🇲🇿',
      },
      {
        key: 'Namibia',
        value: 'Namibia',
        emoji: '🇳🇦',
      },
      {
        key: 'Niger',
        value: 'Niger',
        emoji: '🇳🇪',
      },
      {
        key: 'Nigeria',
        value: 'Nigeria',
        emoji: '🇳🇬',
      },
      {
        key: 'North Macedonia',
        value: 'North Macedonia',
        emoji: '🇲🇰',
      },
      {
        key: 'Norway',
        value: 'Norway',
        emoji: '🇳🇴',
      },
      {
        key: 'Poland',
        value: 'Poland',
        emoji: '🇵🇱',
      },
      {
        key: 'Portugal',
        value: 'Portugal',
        emoji: '🇵🇹',
      },
      {
        key: 'Qatar',
        value: 'Qatar',
        emoji: '🇶🇦',
      },
      {
        key: 'Romania',
        value: 'Romania',
        emoji: '🇷🇴',
      },
      {
        key: 'Russia',
        value: 'Russia',
        emoji: '🇷🇺',
      },
      {
        key: 'Saudi Arabia',
        value: 'Saudi Arabia',
        emoji: '🇸🇦',
      },
      {
        key: 'Serbia',
        value: 'Serbia',
        emoji: '🇷🇸',
      },
      {
        key: 'Seychelles',
        value: 'Seychelles',
        emoji: '🇸🇨',
      },
      {
        key: 'Sierra Leone',
        value: 'Sierra Leone',
        emoji: '🇸🇱',
      },
      {
        key: 'Slovakia',
        value: 'Slovakia',
        emoji: '🇸🇰',
      },
      {
        key: 'Slovenia',
        value: 'Slovenia',
        emoji: '🇸🇮',
      },
      {
        key: 'South Africa',
        value: 'South Africa',
        emoji: '🇿🇦',
      },
      {
        key: 'Spain',
        value: 'Spain',
        emoji: '🇪🇸',
      },
      {
        key: 'Sudan',
        value: 'Sudan',
        emoji: '🇸🇩',
      },
      {
        key: 'Sweden',
        value: 'Sweden',
        emoji: '🇸🇪',
      },
      {
        key: 'Switzerland',
        value: 'Switzerland',
        emoji: '🇨🇭',
      },
      {
        key: 'Syria',
        value: 'Syria',
        emoji: '🇸🇾',
      },
      {
        key: 'Ukraine',
        value: 'Ukraine',
        emoji: '🇺🇦',
      },
      {
        key: 'United Kingdom',
        value: 'United Kingdom',
        emoji: '🇬🇧',
      },
      {
        key: 'United Arab Emirates',
        value: 'United Arab Emirates',
        emoji: '🇦🇪',
      },
    ],
  },
  {
    key: 'Europe',
    value: 'Europe',
    children: [
      {
        key: 'Albania',
        value: 'Albania',
        emoji: '🇦🇱',
      },
      {
        key: 'Andorra',
        value: 'Andorra',
        emoji: '🇦🇩',
      },
      {
        key: 'Austria',
        value: 'Austria',
        emoji: '🇦🇹',
      },
      {
        key: 'Belarus',
        value: 'Belarus',
        emoji: '🇧🇾',
      },
      {
        key: 'Belgium',
        value: 'Belgium',
        emoji: '🇧🇪',
      },
      {
        key: 'Bosnia and Herzegovina',
        value: 'Bosnia and Herzegovina',
        emoji: '🇧🇦',
      },
      {
        key: 'Bulgaria',
        value: 'Bulgaria',
        emoji: '🇧🇬',
      },
      {
        key: 'Croatia',
        value: 'Croatia',
        emoji: '🇭🇷',
      },
      {
        key: 'Cyprus',
        value: 'Cyprus',
        emoji: '🇨🇾',
      },
      {
        key: 'Czechia',
        value: 'Czechia',
      },
      {
        key: 'Denmark',
        value: 'Denmark',
        emoji: '🇩🇰',
      },
      {
        key: 'Estonia',
        value: 'Estonia',
        emoji: '🇪🇪',
      },
      {
        key: 'Finland',
        value: 'Finland',
        emoji: '🇫🇮',
      },
      {
        key: 'France',
        value: 'France',
        emoji: '🇫🇷',
      },
      {
        key: 'Germany',
        value: 'Germany',
        emoji: '🇩🇪',
      },
      {
        key: 'Greece',
        value: 'Greece',
        emoji: '🇬🇷',
      },
      {
        key: 'Hungary',
        value: 'Hungary',
        emoji: '🇭🇺',
      },
      {
        key: 'Iceland',
        value: 'Iceland',
        emoji: '🇮🇸',
      },
      {
        key: 'Ireland',
        value: 'Ireland',
        emoji: '🇮🇪',
      },
      {
        key: 'Italy',
        value: 'Italy',
        emoji: '🇮🇹',
      },
      {
        key: 'Latvia',
        value: 'Latvia',
        emoji: '🇱🇻',
      },
      {
        key: 'Liechtenstein',
        value: 'Liechtenstein',
        emoji: '🇱🇮',
      },
      {
        key: 'Lithuania',
        value: 'Lithuania',
        emoji: '🇱🇹',
      },
      {
        key: 'Luxembourg',
        value: 'Luxembourg',
        emoji: '🇱🇺',
      },
      {
        key: 'Malta',
        value: 'Malta',
        emoji: '🇲🇹',
      },
      {
        key: 'Moldova',
        value: 'Moldova',
        emoji: '🇲🇩',
      },
      {
        key: 'Monaco',
        value: 'Monaco',
        emoji: '🇲🇨',
      },
      {
        key: 'Netherlands',
        value: 'Netherlands',
        emoji: '🇳🇱',
      },
      {
        key: 'Norway',
        value: 'Norway',
        emoji: '🇳🇴',
      },
      {
        key: 'Poland',
        value: 'Poland',
        emoji: '🇵🇱',
      },
      {
        key: 'Portugal',
        value: 'Portugal',
        emoji: '🇵🇹',
      },
      {
        key: 'Romania',
        value: 'Romania',
        emoji: '🇷🇴',
      },
      {
        key: 'Russia',
        value: 'Russia',
        emoji: '🇷🇺',
      },
      {
        key: 'San Marino',
        value: 'San Marino',
        emoji: '🇸🇲',
      },
      {
        key: 'Serbia',
        value: 'Serbia',
        emoji: '🇷🇸',
      },
      {
        key: 'Slovakia',
        value: 'Slovakia',
        emoji: '🇸🇰',
      },
      {
        key: 'Slovenia',
        value: 'Slovenia',
        emoji: '🇸🇮',
      },
      {
        key: 'Spain',
        value: 'Spain',
        emoji: '🇪🇸',
      },
      {
        key: 'Sweden',
        value: 'Sweden',
        emoji: '🇸🇪',
      },
      {
        key: 'Switzerland',
        value: 'Switzerland',
        emoji: '🇨🇭',
      },
      {
        key: 'Ukraine',
        value: 'Ukraine',
        emoji: '🇺🇦',
      },
      {
        key: 'United Kingdom',
        value: 'United Kingdom',
        emoji: '🇬🇧',
      },
      {
        key: 'Vatican City',
        value: 'Vatican City',
      },
    ],
  },
  {
    key: 'Southern Europe',
    value: 'Southern Europe',
    children: [
      {
        key: 'Albania',
        value: 'Albania',
        emoji: '🇦🇱',
      },
      {
        key: 'Andorra',
        value: 'Andorra',
        emoji: '🇦🇩',
      },
      {
        key: 'Bosnia and Herzegovina',
        value: 'Bosnia and Herzegovina',
        emoji: '🇧🇦',
      },
      {
        key: 'Croatia',
        value: 'Croatia',
        emoji: '🇭🇷',
      },
      {
        key: 'Cyprus',
        value: 'Cyprus',
        emoji: '🇨🇾',
      },
      {
        key: 'Greece',
        value: 'Greece',
        emoji: '🇬🇷',
      },
      {
        key: 'Italy',
        value: 'Italy',
        emoji: '🇮🇹',
      },
      {
        key: 'Malta',
        value: 'Malta',
        emoji: '🇲🇹',
      },
      {
        key: 'Monaco',
        value: 'Monaco',
        emoji: '🇲🇨',
      },
      {
        key: 'Montenegro',
        value: 'Montenegro',
        emoji: '🇲🇪',
      },
      {
        key: 'Portugal',
        value: 'Portugal',
        emoji: '🇵🇹',
      },
      {
        key: 'San Marino',
        value: 'San Marino',
        emoji: '🇸🇲',
      },
      {
        key: 'Serbia',
        value: 'Serbia',
        emoji: '🇷🇸',
      },
      {
        key: 'Slovenia',
        value: 'Slovenia',
        emoji: '🇸🇮',
      },
      {
        key: 'Spain',
        value: 'Spain',
        emoji: '🇪🇸',
      },
    ],
  },
  {
    key: 'Eastern Europe',
    value: 'Eastern Europe',
    children: [
      {
        key: 'Belarus',
        value: 'Belarus',
        emoji: '🇧🇾',
      },
      {
        key: 'Bulgaria',
        value: 'Bulgaria',
        emoji: '🇧🇬',
      },
      {
        key: 'Czechia',
        value: 'Czechia',
      },
      {
        key: 'Hungary',
        value: 'Hungary',
        emoji: '🇭🇺',
      },
      {
        key: 'Moldova',
        value: 'Moldova',
        emoji: '🇲🇩',
      },
      {
        key: 'Poland',
        value: 'Poland',
        emoji: '🇵🇱',
      },
      {
        key: 'Romania',
        value: 'Romania',
        emoji: '🇷🇴',
      },
      {
        key: 'Russia',
        value: 'Russia',
        emoji: '🇷🇺',
      },
      {
        key: 'Slovakia',
        value: 'Slovakia',
        emoji: '🇸🇰',
      },
      {
        key: 'Ukraine',
        value: 'Ukraine',
        emoji: '🇺🇦',
      },
    ],
  },
  {
    key: 'Northern Europe',
    value: 'Northern Europe',
    children: [
      {
        key: 'Denmark',
        value: 'Denmark',
        emoji: '🇩🇰',
      },
      {
        key: 'Estonia',
        value: 'Estonia',
        emoji: '🇪🇪',
      },
      {
        key: 'Finland',
        value: 'Finland',
        emoji: '🇫🇮',
      },
      {
        key: 'Iceland',
        value: 'Iceland',
        emoji: '🇮🇸',
      },
      {
        key: 'Ireland',
        value: 'Ireland',
        emoji: '🇮🇪',
      },
      {
        key: 'Latvia',
        value: 'Latvia',
        emoji: '🇱🇻',
      },
      {
        key: 'Lithuania',
        value: 'Lithuania',
        emoji: '🇱🇹',
      },
      {
        key: 'Luxembourg',
        value: 'Luxembourg',
        emoji: '🇱🇺',
      },
      {
        key: 'Malta',
        value: 'Malta',
        emoji: '🇲🇹',
      },
      {
        key: 'Norway',
        value: 'Norway',
        emoji: '🇳🇴',
      },
      {
        key: 'Sweden',
        value: 'Sweden',
        emoji: '🇸🇪',
      },
      {
        key: 'United Kingdom',
        value: 'United Kingdom',
        emoji: '🇬🇧',
      },
    ],
  },
  {
    key: 'Western Europe',
    value: 'Western Europe',
    children: [
      {
        key: 'Austria',
        value: 'Austria',
        emoji: '🇦🇹',
      },
      {
        key: 'Belgium',
        value: 'Belgium',
        emoji: '🇧🇪',
      },
      {
        key: 'France',
        value: 'France',
        emoji: '🇫🇷',
      },
      {
        key: 'Germany',
        value: 'Germany',
        emoji: '🇩🇪',
      },
      {
        key: 'Liechtenstein',
        value: 'Liechtenstein',
        emoji: '🇱🇮',
      },
      {
        key: 'Monaco',
        value: 'Monaco',
        emoji: '🇲🇨',
      },
      {
        key: 'Netherlands',
        value: 'Netherlands',
        emoji: '🇳🇱',
      },
      {
        key: 'Switzerland',
        value: 'Switzerland',
        emoji: '🇨🇭',
      },
    ],
  },
  {
    key: 'European Union',
    value: 'European Union',
    children: [
      {
        key: 'Austria',
        value: 'Austria',
        emoji: '🇦🇹',
      },
      {
        key: 'Belgium',
        value: 'Belgium',
        emoji: '🇧🇪',
      },
      {
        key: 'Cyprus',
        value: 'Cyprus',
        emoji: '🇨🇾',
      },
      {
        key: 'Denmark',
        value: 'Denmark',
        emoji: '🇩🇰',
      },
      {
        key: 'Estonia',
        value: 'Estonia',
        emoji: '🇪🇪',
      },
      {
        key: 'Finland',
        value: 'Finland',
        emoji: '🇫🇮',
      },
      {
        key: 'France',
        value: 'France',
        emoji: '🇫🇷',
      },
      {
        key: 'Germany',
        value: 'Germany',
        emoji: '🇩🇪',
      },
      {
        key: 'Greece',
        value: 'Greece',
        emoji: '🇬🇷',
      },
      {
        key: 'Ireland',
        value: 'Ireland',
        emoji: '🇮🇪',
      },
      {
        key: 'Italy',
        value: 'Italy',
        emoji: '🇮🇹',
      },
      {
        key: 'Latvia',
        value: 'Latvia',
        emoji: '🇱🇻',
      },
      {
        key: 'Lithuania',
        value: 'Lithuania',
        emoji: '🇱🇹',
      },
      {
        key: 'Luxembourg',
        value: 'Luxembourg',
        emoji: '🇱🇺',
      },
      {
        key: 'Malta',
        value: 'Malta',
        emoji: '🇲🇹',
      },
      {
        key: 'Netherlands',
        value: 'Netherlands',
        emoji: '🇳🇱',
      },
      {
        key: 'Poland',
        value: 'Poland',
        emoji: '🇵🇱',
      },
      {
        key: 'Portugal',
        value: 'Portugal',
        emoji: '🇵🇹',
      },
      {
        key: 'Romania',
        value: 'Romania',
        emoji: '🇷🇴',
      },
      {
        key: 'Slovakia',
        value: 'Slovakia',
        emoji: '🇸🇰',
      },
      {
        key: 'Slovenia',
        value: 'Slovenia',
        emoji: '🇸🇮',
      },
      {
        key: 'Spain',
        value: 'Spain',
        emoji: '🇪🇸',
      },
      {
        key: 'Sweden',
        value: 'Sweden',
        emoji: '🇸🇪',
      },
    ],
  },
  {
    key: 'Northern Africa',
    value: 'Northern Africa',
    children: [
      {
        key: 'Algeria',
        value: 'Algeria',
        emoji: '🇩🇿',
      },
      {
        key: 'Egypt',
        value: 'Egypt',
        emoji: '🇪🇬',
      },
      {
        key: 'Libya',
        value: 'Libya',
        emoji: '🇱🇾',
      },
      {
        key: 'Morocco',
        value: 'Morocco',
        emoji: '🇲🇦',
      },
      {
        key: 'Sudan',
        value: 'Sudan',
        emoji: '🇸🇩',
      },
      {
        key: 'Tunisia',
        value: 'Tunisia',
        emoji: '🇹🇳',
      },
    ],
  },
  {
    key: 'Western Africa',
    value: 'Western Africa',
    children: [
      {
        key: 'Benin',
        value: 'Benin',
        emoji: '🇧🇯',
      },
      {
        key: 'Burkina Faso',
        value: 'Burkina Faso',
        emoji: '🇧🇫',
      },
      {
        key: "Côte d'Ivoire",
        value: "Côte d'Ivoire",
      },
      {
        key: 'Gambia',
        value: 'Gambia',
      },
      {
        key: 'Ghana',
        value: 'Ghana',
        emoji: '🇬🇭',
      },
      {
        key: 'Guinea',
        value: 'Guinea',
        emoji: '🇬🇳',
      },
      {
        key: 'Guinea-Bissau',
        value: 'Guinea-Bissau',
        emoji: '🇬🇼',
      },
      {
        key: 'Liberia',
        value: 'Liberia',
        emoji: '🇱🇷',
      },
      {
        key: 'Mali',
        value: 'Mali',
        emoji: '🇲🇱',
      },
      {
        key: 'Mauritania',
        value: 'Mauritania',
        emoji: '🇲🇷',
      },
      {
        key: 'Niger',
        value: 'Niger',
        emoji: '🇳🇪',
      },
      {
        key: 'Nigeria',
        value: 'Nigeria',
        emoji: '🇳🇬',
      },
      {
        key: 'Sao Tome and Principe',
        value: 'Sao Tome and Principe',
        emoji: '🇸🇹',
      },
      {
        key: 'Senegal',
        value: 'Senegal',
        emoji: '🇸🇳',
      },
      {
        key: 'Sierra Leone',
        value: 'Sierra Leone',
        emoji: '🇸🇱',
      },
      {
        key: 'Togo',
        value: 'Togo',
        emoji: '🇹🇬',
      },
    ],
  },
  {
    key: 'Central Africa',
    value: 'Central Africa',
    children: [
      {
        key: 'Central African Republic',
        value: 'Central African Republic',
        emoji: '🇨🇫',
      },
      {
        key: 'Chad',
        value: 'Chad',
        emoji: '🇹🇩',
      },
      {
        key: 'Congo',
        value: 'Congo',
        emoji: '🇨🇬',
      },
      {
        key: 'Equatorial Guinea',
        value: 'Equatorial Guinea',
        emoji: '🇬🇶',
      },
      {
        key: 'Gabon',
        value: 'Gabon',
        emoji: '🇬🇦',
      },
      {
        key: 'Sao Tome and Principe',
        value: 'Sao Tome and Principe',
        emoji: '🇸🇹',
      },
    ],
  },
  {
    key: 'Eastern Africa',
    value: 'Eastern Africa',
    children: [
      {
        key: 'Burundi',
        value: 'Burundi',
        emoji: '🇧🇮',
      },
      {
        key: 'Comoros',
        value: 'Comoros',
        emoji: '🇰🇲',
      },
      {
        key: 'Djibouti',
        value: 'Djibouti',
        emoji: '🇩🇯',
      },
      {
        key: 'Eritrea',
        value: 'Eritrea',
        emoji: '🇪🇷',
      },
      {
        key: 'Ethiopia',
        value: 'Ethiopia',
        emoji: '🇪🇹',
      },
      {
        key: 'Kenya',
        value: 'Kenya',
        emoji: '🇰🇪',
      },
      {
        key: 'Lesotho',
        value: 'Lesotho',
        emoji: '🇱🇸',
      },
      {
        key: 'Liberia',
        value: 'Liberia',
        emoji: '🇱🇷',
      },
      {
        key: 'Madagascar',
        value: 'Madagascar',
        emoji: '🇲🇬',
      },
      {
        key: 'Malawi',
        value: 'Malawi',
        emoji: '🇲🇼',
      },
      {
        key: 'Mauritius',
        value: 'Mauritius',
        emoji: '🇲🇺',
      },
      {
        key: 'Mozambique',
        value: 'Mozambique',
        emoji: '🇲🇿',
      },
      {
        key: 'Rwanda',
        value: 'Rwanda',
        emoji: '🇷🇼',
      },
      {
        key: 'Seychelles',
        value: 'Seychelles',
        emoji: '🇸🇨',
      },
      {
        key: 'Somalia',
        value: 'Somalia',
        emoji: '🇸🇴',
      },
      {
        key: 'South Africa',
        value: 'South Africa',
        emoji: '🇿🇦',
      },
      {
        key: 'South Sudan',
        value: 'South Sudan',
        emoji: '🇸🇸',
      },
      {
        key: 'Tanzania',
        value: 'Tanzania',
        emoji: '🇹🇿',
      },
      {
        key: 'Uganda',
        value: 'Uganda',
        emoji: '🇺🇬',
      },
      {
        key: 'Zambia',
        value: 'Zambia',
        emoji: '🇿🇲',
      },
      {
        key: 'Zimbabwe',
        value: 'Zimbabwe',
        emoji: '🇿🇼',
      },
    ],
  },
  {
    key: 'Southern Africa',
    value: 'Southern Africa',
    children: [
      {
        key: 'Angola',
        value: 'Angola',
        emoji: '🇦🇴',
      },
      {
        key: 'Botswana',
        value: 'Botswana',
        emoji: '🇧🇼',
      },
      {
        key: 'Eswatini',
        value: 'Eswatini',
        emoji: '🇸🇿',
      },
      {
        key: 'Lesotho',
        value: 'Lesotho',
        emoji: '🇱🇸',
      },
      {
        key: 'Malawi',
        value: 'Malawi',
        emoji: '🇲🇼',
      },
      {
        key: 'Mauritius',
        value: 'Mauritius',
        emoji: '🇲🇺',
      },
      {
        key: 'Namibia',
        value: 'Namibia',
        emoji: '🇳🇦',
      },
      {
        key: 'South Africa',
        value: 'South Africa',
        emoji: '🇿🇦',
      },
      {
        key: 'Zambia',
        value: 'Zambia',
        emoji: '🇿🇲',
      },
      {
        key: 'Zimbabwe',
        value: 'Zimbabwe',
        emoji: '🇿🇼',
      },
    ],
  },
  {
    key: 'Africa',
    value: 'Africa',
    children: [
      {
        key: 'Algeria',
        value: 'Algeria',
        emoji: '🇩🇿',
      },
      {
        key: 'Angola',
        value: 'Angola',
        emoji: '🇦🇴',
      },
      {
        key: 'Benin',
        value: 'Benin',
        emoji: '🇧🇯',
      },
      {
        key: 'Botswana',
        value: 'Botswana',
        emoji: '🇧🇼',
      },
      {
        key: 'Burkina Faso',
        value: 'Burkina Faso',
        emoji: '🇧🇫',
      },
      {
        key: 'Burundi',
        value: 'Burundi',
        emoji: '🇧🇮',
      },
      {
        key: 'Cabo Verde',
        value: 'Cabo Verde',
      },
      {
        key: 'Cameroon',
        value: 'Cameroon',
        emoji: '🇨🇲',
      },
      {
        key: 'Central African Republic',
        value: 'Central African Republic',
        emoji: '🇨🇫',
      },
      {
        key: 'Chad',
        value: 'Chad',
        emoji: '🇹🇩',
      },
      {
        key: 'Comoros',
        value: 'Comoros',
        emoji: '🇰🇲',
      },
      {
        key: 'Congo',
        value: 'Congo',
        emoji: '🇨🇬',
      },
      {
        key: "Côte d'Ivoire",
        value: "Côte d'Ivoire",
      },
      {
        key: 'Democratic Republic of the Congo',
        value: 'Democratic Republic of the Congo',
        emoji: '🇨🇩',
      },
      {
        key: 'Djibouti',
        value: 'Djibouti',
        emoji: '🇩🇯',
      },
      {
        key: 'Egypt',
        value: 'Egypt',
        emoji: '🇪🇬',
      },
      {
        key: 'Equatorial Guinea',
        value: 'Equatorial Guinea',
        emoji: '🇬🇶',
      },
      {
        key: 'Eritrea',
        value: 'Eritrea',
        emoji: '🇪🇷',
      },
      {
        key: 'Eswatini',
        value: 'Eswatini',
        emoji: '🇸🇿',
      },
      {
        key: 'Ethiopia',
        value: 'Ethiopia',
        emoji: '🇪🇹',
      },
      {
        key: 'Gabon',
        value: 'Gabon',
        emoji: '🇬🇦',
      },
      {
        key: 'Gambia',
        value: 'Gambia',
      },
      {
        key: 'Ghana',
        value: 'Ghana',
        emoji: '🇬🇭',
      },
      {
        key: 'Guinea',
        value: 'Guinea',
        emoji: '🇬🇳',
      },
      {
        key: 'Guinea-Bissau',
        value: 'Guinea-Bissau',
        emoji: '🇬🇼',
      },
      {
        key: 'Kenya',
        value: 'Kenya',
        emoji: '🇰🇪',
      },
      {
        key: 'Lesotho',
        value: 'Lesotho',
        emoji: '🇱🇸',
      },
      {
        key: 'Liberia',
        value: 'Liberia',
        emoji: '🇱🇷',
      },
      {
        key: 'Libya',
        value: 'Libya',
        emoji: '🇱🇾',
      },
      {
        key: 'Madagascar',
        value: 'Madagascar',
        emoji: '🇲🇬',
      },
      {
        key: 'Malawi',
        value: 'Malawi',
        emoji: '🇲🇼',
      },
      {
        key: 'Mauritania',
        value: 'Mauritania',
        emoji: '🇲🇷',
      },
      {
        key: 'Mauritius',
        value: 'Mauritius',
        emoji: '🇲🇺',
      },
      {
        key: 'Morocco',
        value: 'Morocco',
        emoji: '🇲🇦',
      },
      {
        key: 'Mozambique',
        value: 'Mozambique',
        emoji: '🇲🇿',
      },
      {
        key: 'Namibia',
        value: 'Namibia',
        emoji: '🇳🇦',
      },
      {
        key: 'Niger',
        value: 'Niger',
        emoji: '🇳🇪',
      },
      {
        key: 'Nigeria',
        value: 'Nigeria',
        emoji: '🇳🇬',
      },
      {
        key: 'Rwanda',
        value: 'Rwanda',
        emoji: '🇷🇼',
      },
      {
        key: 'Senegal',
        value: 'Senegal',
        emoji: '🇸🇳',
      },
      {
        key: 'Seychelles',
        value: 'Seychelles',
        emoji: '🇸🇨',
      },
      {
        key: 'Sierra Leone',
        value: 'Sierra Leone',
        emoji: '🇸🇱',
      },
      {
        key: 'Somalia',
        value: 'Somalia',
        emoji: '🇸🇴',
      },
      {
        key: 'South Africa',
        value: 'South Africa',
        emoji: '🇿🇦',
      },
      {
        key: 'South Sudan',
        value: 'South Sudan',
        emoji: '🇸🇸',
      },
      {
        key: 'Sudan',
        value: 'Sudan',
        emoji: '🇸🇩',
      },
      {
        key: 'Tanzania',
        value: 'Tanzania',
        emoji: '🇹🇿',
      },
      {
        key: 'Togo',
        value: 'Togo',
        emoji: '🇹🇬',
      },
      {
        key: 'Tunisia',
        value: 'Tunisia',
        emoji: '🇹🇳',
      },
      {
        key: 'Uganda',
        value: 'Uganda',
        emoji: '🇺🇬',
      },
      {
        key: 'Zambia',
        value: 'Zambia',
        emoji: '🇿🇲',
      },
      {
        key: 'Zimbabwe',
        value: 'Zimbabwe',
        emoji: '🇿🇼',
      },
    ],
  },
  {
    key: 'Oceania',
    value: 'Oceania',
    children: [
      {
        key: 'Australia',
        value: 'Australia',
        emoji: '🇦🇺',
      },
      {
        key: 'Cocos (Keeling) Islands',
        value: 'Cocos (Keeling) Islands',
        emoji: '🇨🇨',
      },
      {
        key: 'Fiji',
        value: 'Fiji',
      },
      {
        key: 'Kiribati',
        value: 'Kiribati',
        emoji: '🇰🇮',
      },
      {
        key: 'Marshall Islands',
        value: 'Marshall Islands',
        emoji: '🇲🇭',
      },
      {
        key: 'Micronesia',
        value: 'Micronesia',
        emoji: '🇫🇲',
      },
      {
        key: 'New Zealand',
        value: 'New Zealand',
        emoji: '🇳🇿',
      },
      {
        key: 'Palau',
        value: 'Palau',
        emoji: '🇵🇼',
      },
      {
        key: 'Papua New Guinea',
        value: 'Papua New Guinea',
        emoji: '🇵🇬',
      },
      {
        key: 'Samoa',
        value: 'Samoa',
        emoji: '🇼🇸',
      },
      {
        key: 'Solomon Islands',
        value: 'Solomon Islands',
        emoji: '🇸🇧',
      },
      {
        key: 'Tonga',
        value: 'Tonga',
        emoji: '🇹🇴',
      },
      {
        key: 'Tuvalu',
        value: 'Tuvalu',
        emoji: '🇹🇻',
      },
      {
        key: 'Vanuatu',
        value: 'Vanuatu',
        emoji: '🇻🇺',
      },
      {
        key: 'Wallis and Futuna',
        value: 'Wallis and Futuna',
      },
      {
        key: 'U.S. Outlying Islands',
        value: 'U.S. Outlying Islands',
      },
    ],
  },
  {
    key: 'Melanesia',
    value: 'Melanesia',
    children: [
      {
        key: 'Fiji',
        value: 'Fiji',
      },
      {
        key: 'Papua New Guinea',
        value: 'Papua New Guinea',
        emoji: '🇵🇬',
      },
      {
        key: 'Solomon Islands',
        value: 'Solomon Islands',
        emoji: '🇸🇧',
      },
      {
        key: 'Vanuatu',
        value: 'Vanuatu',
        emoji: '🇻🇺',
      },
    ],
  },
  {
    key: 'Polynesia',
    value: 'Polynesia',
    children: [
      {
        key: 'Samoa',
        value: 'Samoa',
        emoji: '🇼🇸',
      },
      {
        key: 'Tonga',
        value: 'Tonga',
        emoji: '🇹🇴',
      },
      {
        key: 'Tuvalu',
        value: 'Tuvalu',
        emoji: '🇹🇻',
      },
      {
        key: 'Wallis and Futuna',
        value: 'Wallis and Futuna',
      },
    ],
  },
  {
    key: 'Micronesia',
    value: 'Micronesia',
    children: [
      {
        key: 'Kiribati',
        value: 'Kiribati',
        emoji: '🇰🇮',
      },
      {
        key: 'Marshall Islands',
        value: 'Marshall Islands',
        emoji: '🇲🇭',
      },
      {
        key: 'Micronesia',
        value: 'Micronesia',
        emoji: '🇫🇲',
      },
      {
        key: 'Nauru',
        value: 'Nauru',
        emoji: '🇳🇷',
      },
      {
        key: 'Palau',
        value: 'Palau',
        emoji: '🇵🇼',
      },
    ],
  },
  {
    key: 'Caribbean',
    value: 'Caribbean',
    children: [
      {
        key: 'Antigua and Barbuda',
        value: 'Antigua and Barbuda',
        emoji: '🇦🇬',
      },
      {
        key: 'Bahamas',
        value: 'Bahamas',
      },
      {
        key: 'Barbados',
        value: 'Barbados',
        emoji: '🇧🇧',
      },
      {
        key: 'Bonaire, Sint Eustatius, and Saba',
        value: 'Bonaire, Sint Eustatius, and Saba',
      },
      {
        key: 'Cuba',
        value: 'Cuba',
        emoji: '🇨🇺',
      },
      {
        key: 'Dominica',
        value: 'Dominica',
        emoji: '🇩🇲',
      },
      {
        key: 'Dominican Republic',
        value: 'Dominican Republic',
        emoji: '🇩🇴',
      },
      {
        key: 'Grenada',
        value: 'Grenada',
        emoji: '🇬🇩',
      },
      {
        key: 'Haiti',
        value: 'Haiti',
        emoji: '🇭🇹',
      },
      {
        key: 'Jamaica',
        value: 'Jamaica',
        emoji: '🇯🇲',
      },
      {
        key: 'Saint Kitts and Nevis',
        value: 'Saint Kitts and Nevis',
        emoji: '🇰🇳',
      },
      {
        key: 'Saint Lucia',
        value: 'Saint Lucia',
        emoji: '🇱🇨',
      },
      {
        key: 'Saint Pierre and Miquelon',
        value: 'Saint Pierre and Miquelon',
        emoji: '🇵🇲',
      },
      {
        key: 'Saint Vincent and the Grenadines',
        value: 'Saint Vincent and the Grenadines',
        emoji: '🇻🇨',
      },
      {
        key: 'Trinidad and Tobago',
        value: 'Trinidad and Tobago',
        emoji: '🇹🇹',
      },
    ],
  },
];

export const INDUSTRY_DATA = [
  {
    key: 'Agriculture & Fishing',
    value: 'Agriculture & Fishing',
    children: [
      {
        key: 'Agricultural Chemical Manufacturing',
        value: 'Agricultural Chemical Manufacturing',
      },
      { key: 'Animal Feed Manufacturing', value: 'Animal Feed Manufacturing' },
      { key: 'Dairy', value: 'Dairy' },
      {
        key: 'Dairy Product Manufacturing',
        value: 'Dairy Product Manufacturing',
      },
      { key: 'Farming', value: 'Farming' },
      {
        key: 'Farming, Ranching, Forestry',
        value: 'Farming, Ranching, Forestry',
      },
      { key: 'Fisheries', value: 'Fisheries' },
      { key: 'Forestry and Logging', value: 'Forestry and Logging' },
      {
        key: 'Fruit and Vegetable Preserves Manufacturing',
        value: 'Fruit and Vegetable Preserves Manufacturing',
      },
      { key: 'Horticulture', value: 'Horticulture' },
      {
        key: 'Meat Products Manufacturing',
        value: 'Meat Products Manufacturing',
      },
      { key: 'Ranching', value: 'Ranching' },
      { key: 'Ranching and Fisheries', value: 'Ranching and Fisheries' },
      {
        key: 'Seafood Product Manufacturing',
        value: 'Seafood Product Manufacturing',
      },
      {
        key: 'Wholesale Raw Farm Products',
        value: 'Wholesale Raw Farm Products',
      },
    ],
  },
  {
    key: 'Business Services',
    value: 'Business Services',
    children: [
      { key: 'Accounting', value: 'Accounting' },
      {
        key: 'Administrative and Support Services',
        value: 'Administrative and Support Services',
      },
      { key: 'Advertising Services', value: 'Advertising Services' },
      {
        key: 'Business Consulting and Services',
        value: 'Business Consulting and Services',
      },
      {
        key: 'Business Intelligence Platforms',
        value: 'Business Intelligence Platforms',
      },
      {
        key: 'Business Supplies & Equipment',
        value: 'Business Supplies & Equipment',
      },
      { key: 'Collection Agencies', value: 'Collection Agencies' },
      { key: 'Design Services', value: 'Design Services' },
      { key: 'Events Services', value: 'Events Services' },
      { key: 'Executive Search Services', value: 'Executive Search Services' },
      { key: 'Facilities Services', value: 'Facilities Services' },
      { key: 'Fundraising', value: 'Fundraising' },
      { key: 'Graphic Design', value: 'Graphic Design' },
      { key: 'Human Resources', value: 'Human Resources' },
      { key: 'Human Resources Services', value: 'Human Resources Services' },
      { key: 'Industry Associations', value: 'Industry Associations' },
      { key: 'Janitorial Services', value: 'Janitorial Services' },
      { key: 'Landscaping Services', value: 'Landscaping Services' },
      { key: 'Market Research', value: 'Market Research' },
      { key: 'Marketing Services', value: 'Marketing Services' },
      { key: 'Office Administration', value: 'Office Administration' },
      { key: 'Operations Consulting', value: 'Operations Consulting' },
      {
        key: 'Outsourcing and Offshoring Consulting',
        value: 'Outsourcing and Offshoring Consulting',
      },
      { key: 'Outsourcing/Offshoring', value: 'Outsourcing/Offshoring' },
      {
        key: 'Philanthropic Fundraising Services',
        value: 'Philanthropic Fundraising Services',
      },
      { key: 'Photography', value: 'Photography' },
      { key: 'Printing Services', value: 'Printing Services' },
      {
        key: 'Professional Organizations',
        value: 'Professional Organizations',
      },
      { key: 'Professional Services', value: 'Professional Services' },
      {
        key: 'Professional Training and Coaching',
        value: 'Professional Training and Coaching',
      },
      {
        key: 'Public Relations and Communications Services',
        value: 'Public Relations and Communications Services',
      },
      { key: 'Staffing and Recruiting', value: 'Staffing and Recruiting' },
      {
        key: 'Strategic Management Services',
        value: 'Strategic Management Services',
      },
      { key: 'Temporary Help Services', value: 'Temporary Help Services' },
      {
        key: 'Translation and Localization',
        value: 'Translation and Localization',
      },
      { key: 'Writing and Editing', value: 'Writing and Editing' },
    ],
  },
  {
    key: 'Community & Non-Profit',
    value: 'Community & Non-Profit',
    children: [
      {
        key: 'Civic and Social Organizations',
        value: 'Civic and Social Organizations',
      },
      {
        key: 'Community Development and Urban Planning',
        value: 'Community Development and Urban Planning',
      },
      { key: 'Community Services', value: 'Community Services' },
      { key: 'Conservation Programs', value: 'Conservation Programs' },
      {
        key: 'Emergency and Relief Services',
        value: 'Emergency and Relief Services',
      },
      {
        key: 'Housing and Community Development',
        value: 'Housing and Community Development',
      },
      {
        key: 'Individual and Family Services',
        value: 'Individual and Family Services',
      },
      {
        key: 'Non-profit Organization Management',
        value: 'Non-profit Organization Management',
      },
      { key: 'Non-profit Organizations', value: 'Non-profit Organizations' },
      { key: 'Philanthropy', value: 'Philanthropy' },
      { key: 'Political Organizations', value: 'Political Organizations' },
      { key: 'Program Development', value: 'Program Development' },
      { key: 'Religious Institutions', value: 'Religious Institutions' },
      { key: 'Think Tanks', value: 'Think Tanks' },
      {
        key: 'Vocational Rehabilitation Services',
        value: 'Vocational Rehabilitation Services',
      },
    ],
  },
  {
    key: 'Construction',
    value: 'Construction',
    children: [
      { key: 'Building Construction', value: 'Building Construction' },
      {
        key: 'Building Equipment Contractors',
        value: 'Building Equipment Contractors',
      },
      {
        key: 'Building Finishing Contractors',
        value: 'Building Finishing Contractors',
      },
      { key: 'Building Materials', value: 'Building Materials' },
      {
        key: 'Building Structure and Exterior Contractors',
        value: 'Building Structure and Exterior Contractors',
      },
      { key: 'Civil Engineering', value: 'Civil Engineering' },
      {
        key: 'Construction Hardware Manufacturing',
        value: 'Construction Hardware Manufacturing',
      },
      {
        key: 'Highway, Street, and Bridge Construction',
        value: 'Highway, Street, and Bridge Construction',
      },
      {
        key: 'Nonresidential Building Construction',
        value: 'Nonresidential Building Construction',
      },
      {
        key: 'Residential Building Construction',
        value: 'Residential Building Construction',
      },
      {
        key: 'Specialty Trade Contractors',
        value: 'Specialty Trade Contractors',
      },
      { key: 'Subdivision of Land', value: 'Subdivision of Land' },
      {
        key: 'Utility System Construction',
        value: 'Utility System Construction',
      },
      {
        key: 'Wholesale Building Materials',
        value: 'Wholesale Building Materials',
      },
    ],
  },
  {
    key: 'Personal & Consumer Services',
    value: 'Personal & Consumer Services',
    children: [
      {
        key: 'Bars, Taverns, and Nightclubs',
        value: 'Bars, Taverns, and Nightclubs',
      },
      { key: 'Caterers', value: 'Caterers' },
      {
        key: 'Commercial and Industrial Equipment Rental',
        value: 'Commercial and Industrial Equipment Rental',
      },
      { key: 'Consumer Goods Rental', value: 'Consumer Goods Rental' },
      { key: 'Consumer Services', value: 'Consumer Services' },
      {
        key: 'Cosmetology and Barber Schools',
        value: 'Cosmetology and Barber Schools',
      },
      { key: 'Death Care Services', value: 'Death Care Services' },
      { key: 'Equipment Rental Services', value: 'Equipment Rental Services' },
      {
        key: 'Footwear and Leather Goods Repair',
        value: 'Footwear and Leather Goods Repair',
      },
      { key: 'Funeral Services', value: 'Funeral Services' },
      { key: 'Household Services', value: 'Household Services' },
      {
        key: 'Laundry and Drycleaning Services',
        value: 'Laundry and Drycleaning Services',
      },
      { key: 'Mobile Food Services', value: 'Mobile Food Services' },
      {
        key: 'Personal and Laundry Services',
        value: 'Personal and Laundry Services',
      },
      { key: 'Personal Care Services', value: 'Personal Care Services' },
      { key: 'Pet Services', value: 'Pet Services' },
      { key: 'Repair and Maintenance', value: 'Repair and Maintenance' },
      {
        key: 'Reupholstery and Furniture Repair',
        value: 'Reupholstery and Furniture Repair',
      },
      {
        key: 'Vehicle Repair and Maintenance',
        value: 'Vehicle Repair and Maintenance',
      },
      {
        key: 'Wellness and Fitness Services',
        value: 'Wellness and Fitness Services',
      },
    ],
  },
  {
    key: 'Education Services',
    value: 'Education Services',
    children: [
      { key: 'E-learning', value: 'E-learning' },
      { key: 'E-Learning Providers', value: 'E-Learning Providers' },
      { key: 'Education', value: 'Education' },
      {
        key: 'Education Administration Programs',
        value: 'Education Administration Programs',
      },
      { key: 'Education Management', value: 'Education Management' },
      { key: 'Fine Arts Schools', value: 'Fine Arts Schools' },
      { key: 'Flight Training', value: 'Flight Training' },
      { key: 'Higher Education', value: 'Higher Education' },
      { key: 'Language Schools', value: 'Language Schools' },
      { key: 'Libraries', value: 'Libraries' },
      {
        key: 'Primary and Secondary Education',
        value: 'Primary and Secondary Education',
      },
      {
        key: 'Professional Training and Coaching',
        value: 'Professional Training and Coaching',
      },
      { key: 'Secretarial Schools', value: 'Secretarial Schools' },
      {
        key: 'Sports and Recreation Instruction',
        value: 'Sports and Recreation Instruction',
      },
      {
        key: 'Technical and Vocational Training',
        value: 'Technical and Vocational Training',
      },
    ],
  },
  {
    key: 'Energy, Utilities & Waste',
    value: 'Energy, Utilities & Waste',
    children: [
      {
        key: 'Biomass Electric Power Generation',
        value: 'Biomass Electric Power Generation',
      },
      {
        key: 'Climate Data and Analytics',
        value: 'Climate Data and Analytics',
      },
      {
        key: 'Climate Technology Product Manufacturing',
        value: 'Climate Technology Product Manufacturing',
      },
      { key: 'Coal Mining', value: 'Coal Mining' },
      { key: 'Electric Power Generation', value: 'Electric Power Generation' },
      {
        key: 'Electric Power Transmission, Control, and Distribution',
        value: 'Electric Power Transmission, Control, and Distribution',
      },
      { key: 'Energy Technology', value: 'Energy Technology' },
      {
        key: 'Environmental Quality Programs',
        value: 'Environmental Quality Programs',
      },
      { key: 'Environmental Services', value: 'Environmental Services' },
      {
        key: 'Fossil Fuel Electric Power Generation',
        value: 'Fossil Fuel Electric Power Generation',
      },
      { key: 'Fuel Cell Manufacturing', value: 'Fuel Cell Manufacturing' },
      {
        key: 'Geothermal Electric Power Generation',
        value: 'Geothermal Electric Power Generation',
      },
      {
        key: 'Hydroelectric Power Generation',
        value: 'Hydroelectric Power Generation',
      },
      { key: 'Natural Gas Distribution', value: 'Natural Gas Distribution' },
      { key: 'Natural Gas Extraction', value: 'Natural Gas Extraction' },
      {
        key: 'Nuclear Electric Power Generation',
        value: 'Nuclear Electric Power Generation',
      },
      {
        key: 'Oil and Coal Product Manufacturing',
        value: 'Oil and Coal Product Manufacturing',
      },
      { key: 'Oil and Gas', value: 'Oil and Gas' },
      { key: 'Oil Extraction', value: 'Oil Extraction' },
      { key: 'Oil, Gas, and Mining', value: 'Oil, Gas, and Mining' },
      { key: 'Pipeline Transportation', value: 'Pipeline Transportation' },
      {
        key: 'Renewable Energy Equipment Manufacturing',
        value: 'Renewable Energy Equipment Manufacturing',
      },
      {
        key: 'Renewable Energy Power Generation',
        value: 'Renewable Energy Power Generation',
      },
      {
        key: 'Renewable Energy Semiconductor Manufacturing',
        value: 'Renewable Energy Semiconductor Manufacturing',
      },
      { key: 'Renewables & Environment', value: 'Renewables & Environment' },
      {
        key: 'Services for Renewable Energy',
        value: 'Services for Renewable Energy',
      },
      {
        key: 'Smart Meter Manufacturing',
        value: 'Smart Meter Manufacturing',
      },
      {
        key: 'Solar Electric Power Generation',
        value: 'Solar Electric Power Generation',
      },
      {
        key: 'Steam and Air-Conditioning Supply',
        value: 'Steam and Air-Conditioning Supply',
      },
      { key: 'Utilities', value: 'Utilities' },
      { key: 'Utilities Administration', value: 'Utilities Administration' },
      { key: 'Waste Collection', value: 'Waste Collection' },
      {
        key: 'Waste Treatment and Disposal',
        value: 'Waste Treatment and Disposal',
      },
      {
        key: 'Water Supply and Irrigation Systems',
        value: 'Water Supply and Irrigation Systems',
      },
      {
        key: 'Water, Waste, Steam, and Air Conditioning Services',
        value: 'Water, Waste, Steam, and Air Conditioning Services',
      },
      {
        key: 'Wind Electric Power Generation',
        value: 'Wind Electric Power Generation',
      },
      {
        key: 'Wholesale Petroleum and Petroleum Products',
        value: 'Wholesale Petroleum and Petroleum Products',
      },
    ],
  },
  {
    key: 'Finance',
    value: 'Finance',
    children: [
      { key: 'Banking', value: 'Banking' },
      { key: 'Blockchain Services', value: 'Blockchain Services' },
      { key: 'Capital Markets', value: 'Capital Markets' },
      {
        key: 'Claims Adjusting, Actuarial Services',
        value: 'Claims Adjusting, Actuarial Services',
      },
      { key: 'Credit Intermediation', value: 'Credit Intermediation' },
      { key: 'Economic Programs', value: 'Economic Programs' },
      { key: 'Financial Services', value: 'Financial Services' },
      { key: 'Funds and Trusts', value: 'Funds and Trusts' },
      { key: 'Holding Companies', value: 'Holding Companies' },
      { key: 'Investment Advice', value: 'Investment Advice' },
      { key: 'Investment Banking', value: 'Investment Banking' },
      { key: 'Investment Management', value: 'Investment Management' },
      { key: 'Loan Brokers', value: 'Loan Brokers' },
      { key: 'Pension Funds', value: 'Pension Funds' },
      { key: 'Savings Institutions', value: 'Savings Institutions' },
      {
        key: 'Securities and Commodity Exchanges',
        value: 'Securities and Commodity Exchanges',
      },
      { key: 'Trusts and Estates', value: 'Trusts and Estates' },
      {
        key: 'Venture Capital and Private Equity Principals',
        value: 'Venture Capital and Private Equity Principals',
      },
    ],
  },
  {
    key: 'Government & Public Sector',
    value: 'Government & Public Sector',
    children: [
      { key: 'Administration of Justice', value: 'Administration of Justice' },
      {
        key: 'Air, Water, and Waste Program Management',
        value: 'Air, Water, and Waste Program Management',
      },
      { key: 'Armed Forces', value: 'Armed Forces' },
      { key: 'Correctional Institutions', value: 'Correctional Institutions' },
      { key: 'Courts of Law', value: 'Courts of Law' },
      { key: 'Defense & Space', value: 'Defense & Space' },
      { key: 'Executive Offices', value: 'Executive Offices' },
      { key: 'Fire Protection', value: 'Fire Protection' },
      {
        key: 'Government Administration',
        value: 'Government Administration',
      },
      { key: 'Government Relations', value: 'Government Relations' },
      {
        key: 'Government Relations Services',
        value: 'Government Relations Services',
      },
      { key: 'Housing Programs', value: 'Housing Programs' },
      { key: 'International Affairs', value: 'International Affairs' },
      { key: 'Law Enforcement', value: 'Law Enforcement' },
      { key: 'Legislative Offices', value: 'Legislative Offices' },
      {
        key: 'Military and International Affairs',
        value: 'Military and International Affairs',
      },
      { key: 'Political Organizations', value: 'Political Organizations' },
      {
        key: 'Public Assistance Programs',
        value: 'Public Assistance Programs',
      },
      { key: 'Public Health', value: 'Public Health' },
      { key: 'Public Policy', value: 'Public Policy' },
      { key: 'Public Policy Offices', value: 'Public Policy Offices' },
      { key: 'Public Safety', value: 'Public Safety' },
      { key: 'Public Works', value: 'Public Works' },
      { key: 'Transportation Programs', value: 'Transportation Programs' },
      { key: 'Utilities Administration', value: 'Utilities Administration' },
    ],
  },
  {
    key: 'Healthcare',
    value: 'Healthcare',
    children: [
      { key: 'Alternative Medicine', value: 'Alternative Medicine' },
      { key: 'Ambulance Services', value: 'Ambulance Services' },
      { key: 'Biotechnology', value: 'Biotechnology' },
      { key: 'Biotechnology Research', value: 'Biotechnology Research' },
      { key: 'Chiropractors', value: 'Chiropractors' },
      { key: 'Dentists', value: 'Dentists' },
      {
        key: 'Family Planning Centers',
        value: 'Family Planning Centers',
      },
      {
        key: 'Health and Human Services',
        value: 'Health and Human Services',
      },
      {
        key: 'Health, Wellness & Fitness',
        value: 'Health, Wellness & Fitness',
      },
      {
        key: 'Home Health Care Services',
        value: 'Home Health Care Services',
      },
      { key: 'Hospitals', value: 'Hospitals' },
      {
        key: 'Hospitals and Health Care',
        value: 'Hospitals and Health Care',
      },
      {
        key: 'Medical and Diagnostic Laboratories',
        value: 'Medical and Diagnostic Laboratories',
      },
      { key: 'Medical Device', value: 'Medical Device' },
      {
        key: 'Medical Equipment Manufacturing',
        value: 'Medical Equipment Manufacturing',
      },
      { key: 'Medical Practices', value: 'Medical Practices' },
      { key: 'Mental Health Care', value: 'Mental Health Care' },
      {
        key: 'Nursing Homes and Residential Care Facilities',
        value: 'Nursing Homes and Residential Care Facilities',
      },
      { key: 'Optometrists', value: 'Optometrists' },
      { key: 'Outpatient Care Centers', value: 'Outpatient Care Centers' },
      {
        key: 'Personal Care Product Manufacturing',
        value: 'Personal Care Product Manufacturing',
      },
      {
        key: 'Pharmaceutical Manufacturing',
        value: 'Pharmaceutical Manufacturing',
      },
      {
        key: 'Physical, Occupational and Speech Therapists',
        value: 'Physical, Occupational and Speech Therapists',
      },
      { key: 'Physicians', value: 'Physicians' },
      { key: 'Public Health', value: 'Public Health' },
      {
        key: 'Services for the Elderly and Disabled',
        value: 'Services for the Elderly and Disabled',
      },
      { key: 'Veterinary', value: 'Veterinary' },
      { key: 'Veterinary Services', value: 'Veterinary Services' },
      {
        key: 'Wholesale Drugs and Sundries',
        value: 'Wholesale Drugs and Sundries',
      },
    ],
  },
  {
    key: 'Leisure & Hospitality',
    value: 'Leisure & Hospitality',
    children: [
      {
        key: 'Accommodation and Food Services',
        value: 'Accommodation and Food Services',
      },
      {
        key: 'Amusement Parks and Arcades',
        value: 'Amusement Parks and Arcades',
      },
      {
        key: 'Bed-and-Breakfasts, Hostels, Homestays',
        value: 'Bed-and-Breakfasts, Hostels, Homestays',
      },
      {
        key: 'Circuses and Magic Shows',
        value: 'Circuses and Magic Shows',
      },
      { key: 'Dance Companies', value: 'Dance Companies' },
      { key: 'Entertainment', value: 'Entertainment' },
      {
        key: 'Entertainment Providers',
        value: 'Entertainment Providers',
      },
      { key: 'Food & Beverages', value: 'Food & Beverages' },
      {
        key: 'Food and Beverage Services',
        value: 'Food and Beverage Services',
      },
      {
        key: 'Gambling Facilities and Casinos',
        value: 'Gambling Facilities and Casinos',
      },
      {
        key: 'Golf Courses and Country Clubs',
        value: 'Golf Courses and Country Clubs',
      },
      { key: 'Historical Sites', value: 'Historical Sites' },
      { key: 'Hospitality', value: 'Hospitality' },
      { key: 'Hotels and Motels', value: 'Hotels and Motels' },
      {
        key: 'Leisure, Travel & Tourism',
        value: 'Leisure, Travel & Tourism',
      },
      { key: 'Museums', value: 'Museums' },
      {
        key: 'Museums, Historical Sites, and Zoos',
        value: 'Museums, Historical Sites, and Zoos',
      },
      { key: 'Music', value: 'Music' },
      { key: 'Musicians', value: 'Musicians' },
      { key: 'Performing Arts', value: 'Performing Arts' },
      {
        key: 'Performing Arts and Spectator Sports',
        value: 'Performing Arts and Spectator Sports',
      },
      { key: 'Racetracks', value: 'Racetracks' },
      {
        key: 'Recreational Facilities',
        value: 'Recreational Facilities',
      },
      { key: 'Restaurants', value: 'Restaurants' },
      { key: 'Skiing Facilities', value: 'Skiing Facilities' },
      { key: 'Spectator Sports', value: 'Spectator Sports' },
      { key: 'Sports Teams and Clubs', value: 'Sports Teams and Clubs' },
      { key: 'Theater Companies', value: 'Theater Companies' },
      { key: 'Travel Arrangements', value: 'Travel Arrangements' },
      {
        key: 'Zoos and Botanical Gardens',
        value: 'Zoos and Botanical Gardens',
      },
    ],
  },
  {
    key: 'Insurance Services',
    value: 'Insurance Services',
    children: [
      { key: 'Insurance', value: 'Insurance' },
      {
        key: 'Insurance Agencies and Brokerages',
        value: 'Insurance Agencies and Brokerages',
      },
      {
        key: 'Insurance and Employee Benefit Funds',
        value: 'Insurance and Employee Benefit Funds',
      },
      { key: 'Insurance Carriers', value: 'Insurance Carriers' },
    ],
  },
  {
    key: 'Law Firms & Legal Services',
    value: 'Law Firms & Legal Services',
    children: [
      { key: 'Administration of Justice', value: 'Administration of Justice' },
      {
        key: 'Alternative Dispute Resolution',
        value: 'Alternative Dispute Resolution',
      },
      { key: 'Courts of Law', value: 'Courts of Law' },
      { key: 'Law Enforcement', value: 'Law Enforcement' },
      { key: 'Law Practice', value: 'Law Practice' },
      { key: 'Legal Services', value: 'Legal Services' },
    ],
  },
  {
    key: 'Logistics & Supply Chain',
    value: 'Logistics & Supply Chain',
    children: [
      {
        key: 'Freight and Package Transportation',
        value: 'Freight and Package Transportation',
      },
      { key: 'Import & Export', value: 'Import & Export' },
      {
        key: 'International Trade and Development',
        value: 'International Trade and Development',
      },
      { key: 'Parts Distribution', value: 'Parts Distribution' },
      { key: 'Postal Services', value: 'Postal Services' },
      {
        key: 'Transportation, Logistics, Supply Chain and Storage',
        value: 'Transportation, Logistics, Supply Chain and Storage',
      },
      { key: 'Warehousing', value: 'Warehousing' },
      { key: 'Warehousing and Storage', value: 'Warehousing and Storage' },
      { key: 'Wholesale', value: 'Wholesale' },
      {
        key: 'Wholesale Alcoholic Beverages',
        value: 'Wholesale Alcoholic Beverages',
      },
      {
        key: 'Wholesale Apparel and Sewing Supplies',
        value: 'Wholesale Apparel and Sewing Supplies',
      },
      {
        key: 'Wholesale Appliances, Electrical, and Electronics',
        value: 'Wholesale Appliances, Electrical, and Electronics',
      },
      {
        key: 'Wholesale Chemical and Allied Products',
        value: 'Wholesale Chemical and Allied Products',
      },
      {
        key: 'Wholesale Computer Equipment',
        value: 'Wholesale Computer Equipment',
      },
      {
        key: 'Wholesale Food and Beverage',
        value: 'Wholesale Food and Beverage',
      },
      { key: 'Wholesale Footwear', value: 'Wholesale Footwear' },
      {
        key: 'Wholesale Furniture and Home Furnishings',
        value: 'Wholesale Furniture and Home Furnishings',
      },
      {
        key: 'Wholesale Hardware, Plumbing, Heating Equipment',
        value: 'Wholesale Hardware, Plumbing, Heating Equipment',
      },
      {
        key: 'Wholesale Import and Export',
        value: 'Wholesale Import and Export',
      },
      {
        key: 'Wholesale Luxury Goods and Jewelry',
        value: 'Wholesale Luxury Goods and Jewelry',
      },
      { key: 'Wholesale Machinery', value: 'Wholesale Machinery' },
      {
        key: 'Wholesale Metals and Minerals',
        value: 'Wholesale Metals and Minerals',
      },
      {
        key: 'Wholesale Motor Vehicles and Parts',
        value: 'Wholesale Motor Vehicles and Parts',
      },
      { key: 'Wholesale Paper Products', value: 'Wholesale Paper Products' },
      {
        key: 'Wholesale Photography Equipment and Supplies',
        value: 'Wholesale Photography Equipment and Supplies',
      },
      {
        key: 'Wholesale Recyclable Materials',
        value: 'Wholesale Recyclable Materials',
      },
    ],
  },
  {
    key: 'Manufacturing & Production',
    value: 'Manufacturing & Production',
    children: [
      {
        key: 'Abrasives and Nonmetallic Minerals Manufacturing',
        value: 'Abrasives and Nonmetallic Minerals Manufacturing',
      },
      {
        key: 'Accessible Hardware Manufacturing',
        value: 'Accessible Hardware Manufacturing',
      },
      {
        key: 'Alternative Fuel Vehicle Manufacturing',
        value: 'Alternative Fuel Vehicle Manufacturing',
      },
      { key: 'Apparel Manufacturing', value: 'Apparel Manufacturing' },
      {
        key: 'Appliances, Electrical, and Electronics Manufacturing',
        value: 'Appliances, Electrical, and Electronics Manufacturing',
      },
      {
        key: 'Architectural and Structural Metal Manufacturing',
        value: 'Architectural and Structural Metal Manufacturing',
      },
      {
        key: 'Artificial Rubber and Synthetic Fiber Manufacturing',
        value: 'Artificial Rubber and Synthetic Fiber Manufacturing',
      },
      {
        key: 'Audio and Video Equipment Manufacturing',
        value: 'Audio and Video Equipment Manufacturing',
      },
      {
        key: 'Automation Machinery Manufacturing',
        value: 'Automation Machinery Manufacturing',
      },
      { key: 'Baked Goods Manufacturing', value: 'Baked Goods Manufacturing' },
      { key: 'Beverage Manufacturing', value: 'Beverage Manufacturing' },
      {
        key: 'Boilers, Tanks, and Shipping Container Manufacturing',
        value: 'Boilers, Tanks, and Shipping Container Manufacturing',
      },
      { key: 'Chemical Manufacturing', value: 'Chemical Manufacturing' },
      {
        key: 'Chemical Raw Materials Manufacturing',
        value: 'Chemical Raw Materials Manufacturing',
      },
      {
        key: 'Clay and Refractory Products Manufacturing',
        value: 'Clay and Refractory Products Manufacturing',
      },
      {
        key: 'Communications Equipment Manufacturing',
        value: 'Communications Equipment Manufacturing',
      },
      {
        key: 'Computer Hardware Manufacturing',
        value: 'Computer Hardware Manufacturing',
      },
      {
        key: 'Computers and Electronics Manufacturing',
        value: 'Computers and Electronics Manufacturing',
      },
      { key: 'Consumer Electronics', value: 'Consumer Electronics' },
      { key: 'Consumer Goods', value: 'Consumer Goods' },
      {
        key: 'Cutlery and Handtool Manufacturing',
        value: 'Cutlery and Handtool Manufacturing',
      },
      {
        key: 'Defense and Space Manufacturing',
        value: 'Defense and Space Manufacturing',
      },
      {
        key: 'Electric Lighting Equipment Manufacturing',
        value: 'Electric Lighting Equipment Manufacturing',
      },
      {
        key: 'Electrical Equipment Manufacturing',
        value: 'Electrical Equipment Manufacturing',
      },
      {
        key: 'Engines and Power Transmission Equipment Manufacturing',
        value: 'Engines and Power Transmission Equipment Manufacturing',
      },
      { key: 'Fabricated Metal Products', value: 'Fabricated Metal Products' },
      {
        key: 'Fashion Accessories Manufacturing',
        value: 'Fashion Accessories Manufacturing',
      },
      {
        key: 'Food and Beverage Manufacturing',
        value: 'Food and Beverage Manufacturing',
      },
      { key: 'Food Production', value: 'Food Production' },
      { key: 'Footwear Manufacturing', value: 'Footwear Manufacturing' },
      {
        key: 'Furniture and Home Furnishings Manufacturing',
        value: 'Furniture and Home Furnishings Manufacturing',
      },
      {
        key: 'Glass Product Manufacturing',
        value: 'Glass Product Manufacturing',
      },
      {
        key: 'Glass, Ceramics and Concrete Manufacturing',
        value: 'Glass, Ceramics and Concrete Manufacturing',
      },
      {
        key: 'Household and Institutional Furniture Manufacturing',
        value: 'Household and Institutional Furniture Manufacturing',
      },
      {
        key: 'Household Appliance Manufacturing',
        value: 'Household Appliance Manufacturing',
      },
      {
        key: 'HVAC and Refrigeration Equipment Manufacturing',
        value: 'HVAC and Refrigeration Equipment Manufacturing',
      },
      {
        key: 'Industrial Machinery Manufacturing',
        value: 'Industrial Machinery Manufacturing',
      },
      {
        key: 'Leather Product Manufacturing',
        value: 'Leather Product Manufacturing',
      },
      { key: 'Machinery Manufacturing', value: 'Machinery Manufacturing' },
      {
        key: 'Magnetic and Optical Media Manufacturing',
        value: 'Magnetic and Optical Media Manufacturing',
      },
      { key: 'Manufacturing', value: 'Manufacturing' },
      {
        key: 'Mattress and Blinds Manufacturing',
        value: 'Mattress and Blinds Manufacturing',
      },
      {
        key: 'Measuring and Control Instrument Manufacturing',
        value: 'Measuring and Control Instrument Manufacturing',
      },
      {
        key: 'Metal Valve, Ball, and Roller Manufacturing',
        value: 'Metal Valve, Ball, and Roller Manufacturing',
      },
      {
        key: 'Metalworking Machinery Manufacturing',
        value: 'Metalworking Machinery Manufacturing',
      },
      {
        key: 'Motor Vehicle Manufacturing',
        value: 'Motor Vehicle Manufacturing',
      },
      {
        key: 'Motor Vehicle Parts Manufacturing',
        value: 'Motor Vehicle Parts Manufacturing',
      },
      {
        key: 'Office Furniture and Fixtures Manufacturing',
        value: 'Office Furniture and Fixtures Manufacturing',
      },
      { key: 'Packaging & Containers', value: 'Packaging & Containers' },
      {
        key: 'Packaging and Containers Manufacturing',
        value: 'Packaging and Containers Manufacturing',
      },
      {
        key: 'Paint, Coating, and Adhesive Manufacturing',
        value: 'Paint, Coating, and Adhesive Manufacturing',
      },
      { key: 'Paper & Forest Products', value: 'Paper & Forest Products' },
      {
        key: 'Paper and Forest Product Manufacturing',
        value: 'Paper and Forest Product Manufacturing',
      },
      {
        key: 'Plastics and Rubber Product Manufacturing',
        value: 'Plastics and Rubber Product Manufacturing',
      },
      { key: 'Plastics Manufacturing', value: 'Plastics Manufacturing' },
      {
        key: 'Primary Metal Manufacturing',
        value: 'Primary Metal Manufacturing',
      },
      {
        key: 'Railroad Equipment Manufacturing',
        value: 'Railroad Equipment Manufacturing',
      },
      { key: 'Robot Manufacturing', value: 'Robot Manufacturing' },
      {
        key: 'Rubber Products Manufacturing',
        value: 'Rubber Products Manufacturing',
      },
      {
        key: 'Semiconductor Manufacturing',
        value: 'Semiconductor Manufacturing',
      },
      { key: 'Shipbuilding', value: 'Shipbuilding' },
      {
        key: 'Soap and Cleaning Product Manufacturing',
        value: 'Soap and Cleaning Product Manufacturing',
      },
      {
        key: 'Sporting Goods Manufacturing',
        value: 'Sporting Goods Manufacturing',
      },
      {
        key: 'Spring and Wire Product Manufacturing',
        value: 'Spring and Wire Product Manufacturing',
      },
      {
        key: 'Sugar and Confectionery Product Manufacturing',
        value: 'Sugar and Confectionery Product Manufacturing',
      },
      { key: 'Textile Manufacturing', value: 'Textile Manufacturing' },
      { key: 'Tobacco Manufacturing', value: 'Tobacco Manufacturing' },
      {
        key: 'Transportation Equipment Manufacturing',
        value: 'Transportation Equipment Manufacturing',
      },
      {
        key: 'Turned Products and Fastener Manufacturing',
        value: 'Turned Products and Fastener Manufacturing',
      },
      {
        key: "Women's Handbag Manufacturing",
        value: "Women's Handbag Manufacturing",
      },
      {
        key: 'Wood Product Manufacturing',
        value: 'Wood Product Manufacturing',
      },
    ],
  },
  {
    key: 'Media & Internet',
    value: 'Media & Internet',
    children: [
      { key: 'Animation', value: 'Animation' },
      {
        key: 'Animation and Post-production',
        value: 'Animation and Post-production',
      },
      { key: 'Blogs', value: 'Blogs' },
      {
        key: 'Book and Periodical Publishing',
        value: 'Book and Periodical Publishing',
      },
      { key: 'Book Publishing', value: 'Book Publishing' },
      {
        key: 'Broadcast Media Production and Distribution',
        value: 'Broadcast Media Production and Distribution',
      },
      { key: 'Business Content', value: 'Business Content' },
      {
        key: 'Cable and Satellite Programming',
        value: 'Cable and Satellite Programming',
      },
      { key: 'Computer Games', value: 'Computer Games' },
      { key: 'Fine Art', value: 'Fine Art' },
      {
        key: 'Internet Marketplace Platforms',
        value: 'Internet Marketplace Platforms',
      },
      { key: 'Internet News', value: 'Internet News' },
      { key: 'Internet Publishing', value: 'Internet Publishing' },
      {
        key: 'Media and Telecommunications',
        value: 'Media and Telecommunications',
      },
      { key: 'Media Production', value: 'Media Production' },
      { key: 'Mobile Gaming Apps', value: 'Mobile Gaming Apps' },
      {
        key: 'Movies and Sound Recording',
        value: 'Movies and Sound Recording',
      },
      {
        key: 'Movies, Videos, and Sound',
        value: 'Movies, Videos, and Sound',
      },
      { key: 'Newspaper Publishing', value: 'Newspaper Publishing' },
      {
        key: 'Online Audio and Video Media',
        value: 'Online Audio and Video Media',
      },
      { key: 'Online Media', value: 'Online Media' },
      { key: 'Periodical Publishing', value: 'Periodical Publishing' },
      {
        key: 'Radio and Television Broadcasting',
        value: 'Radio and Television Broadcasting',
      },
      { key: 'Sheet Music Publishing', value: 'Sheet Music Publishing' },
      {
        key: 'Social Networking Platforms',
        value: 'Social Networking Platforms',
      },
      { key: 'Sound Recording', value: 'Sound Recording' },
      {
        key: 'Technology, Information and Internet',
        value: 'Technology, Information and Internet',
      },
      {
        key: 'Technology, Information and Media',
        value: 'Technology, Information and Media',
      },
    ],
  },
  {
    key: 'Metals & Mining',
    value: 'Metals & Mining',
    children: [
      { key: 'Coal Mining', value: 'Coal Mining' },
      { key: 'Metal Ore Mining', value: 'Metal Ore Mining' },
      { key: 'Metal Treatments', value: 'Metal Treatments' },
      { key: 'Mining', value: 'Mining' },
      {
        key: 'Nonmetallic Mineral Mining',
        value: 'Nonmetallic Mineral Mining',
      },
      { key: 'Oil, Gas, and Mining', value: 'Oil, Gas, and Mining' },
      {
        key: 'Primary Metal Manufacturing',
        value: 'Primary Metal Manufacturing',
      },
      {
        key: 'Wholesale Metals and Minerals',
        value: 'Wholesale Metals and Minerals',
      },
    ],
  },
  {
    key: 'Real Estate Services',
    value: 'Real Estate Services',
    children: [
      {
        key: 'Accessible Architecture and Design',
        value: 'Accessible Architecture and Design',
      },
      {
        key: 'Architecture and Planning',
        value: 'Architecture and Planning',
      },
      { key: 'Commercial Real Estate', value: 'Commercial Real Estate' },
      { key: 'Interior Design', value: 'Interior Design' },
      {
        key: 'Leasing Non-residential Real Estate',
        value: 'Leasing Non-residential Real Estate',
      },
      {
        key: 'Leasing Residential Real Estate',
        value: 'Leasing Residential Real Estate',
      },
      { key: 'Real Estate', value: 'Real Estate' },
      {
        key: 'Real Estate Agents and Brokers',
        value: 'Real Estate Agents and Brokers',
      },
      {
        key: 'Real Estate and Equipment Rental Services',
        value: 'Real Estate and Equipment Rental Services',
      },
      { key: 'Regenerative Design', value: 'Regenerative Design' },
      {
        key: 'Residential Building Construction',
        value: 'Residential Building Construction',
      },
      { key: 'Subdivision of Land', value: 'Subdivision of Land' },
      {
        key: 'Surveying and Mapping Services',
        value: 'Surveying and Mapping Services',
      },
    ],
  },
  {
    key: 'Research & Technology',
    value: 'Research & Technology',
    children: [
      { key: 'Biotechnology Research', value: 'Biotechnology Research' },
      {
        key: 'Climate Data and Analytics',
        value: 'Climate Data and Analytics',
      },
      {
        key: 'Data Infrastructure and Analytics',
        value: 'Data Infrastructure and Analytics',
      },
      {
        key: 'Data Security Software Products',
        value: 'Data Security Software Products',
      },
      { key: 'Defense & Space', value: 'Defense & Space' },
      { key: 'Engineering Services', value: 'Engineering Services' },
      { key: 'Industrial Automation', value: 'Industrial Automation' },
      { key: 'Market Research', value: 'Market Research' },
      {
        key: 'Mechanical Or Industrial Engineering',
        value: 'Mechanical Or Industrial Engineering',
      },
      { key: 'Nanotechnology Research', value: 'Nanotechnology Research' },
      { key: 'Research', value: 'Research' },
      { key: 'Research Services', value: 'Research Services' },
      { key: 'Robotics Engineering', value: 'Robotics Engineering' },
      {
        key: 'Space Research and Technology',
        value: 'Space Research and Technology',
      },
      { key: 'Think Tanks', value: 'Think Tanks' },
    ],
  },
  {
    key: 'Retail & Commerce',
    value: 'Retail & Commerce',
    children: [
      { key: 'Consumer Goods', value: 'Consumer Goods' },
      {
        key: 'Food and Beverage Retail',
        value: 'Food and Beverage Retail',
      },
      { key: 'Luxury Goods & Jewelry', value: 'Luxury Goods & Jewelry' },
      {
        key: 'Online and Mail Order Retail',
        value: 'Online and Mail Order Retail',
      },
      { key: 'Retail', value: 'Retail' },
      {
        key: 'Retail Apparel and Fashion',
        value: 'Retail Apparel and Fashion',
      },
      {
        key: 'Retail Appliances, Electrical, and Electronic Equipment',
        value: 'Retail Appliances, Electrical, and Electronic Equipment',
      },
      { key: 'Retail Art Dealers', value: 'Retail Art Dealers' },
      { key: 'Retail Art Supplies', value: 'Retail Art Supplies' },
      {
        key: 'Retail Books and Printed News',
        value: 'Retail Books and Printed News',
      },
      {
        key: 'Retail Building Materials and Garden Equipment',
        value: 'Retail Building Materials and Garden Equipment',
      },
      { key: 'Retail Florists', value: 'Retail Florists' },
      {
        key: 'Retail Furniture and Home Furnishings',
        value: 'Retail Furniture and Home Furnishings',
      },
      { key: 'Retail Gasoline', value: 'Retail Gasoline' },
      { key: 'Retail Groceries', value: 'Retail Groceries' },
      {
        key: 'Retail Health and Personal Care Products',
        value: 'Retail Health and Personal Care Products',
      },
      {
        key: 'Retail Luxury Goods and Jewelry',
        value: 'Retail Luxury Goods and Jewelry',
      },
      { key: 'Retail Motor Vehicles', value: 'Retail Motor Vehicles' },
      {
        key: 'Retail Musical Instruments',
        value: 'Retail Musical Instruments',
      },
      { key: 'Retail Office Equipment', value: 'Retail Office Equipment' },
      {
        key: 'Retail Office Supplies and Gifts',
        value: 'Retail Office Supplies and Gifts',
      },
      { key: 'Retail Pharmacies', value: 'Retail Pharmacies' },
      {
        key: 'Retail Recyclable Materials & Used Merchandise',
        value: 'Retail Recyclable Materials & Used Merchandise',
      },
      { key: 'Sporting Goods', value: 'Sporting Goods' },
    ],
  },
  {
    key: 'IT & Software',
    value: 'IT & Software',
    children: [
      { key: 'Blockchain Services', value: 'Blockchain Services' },
      {
        key: 'Computer and Network Security',
        value: 'Computer and Network Security',
      },
      { key: 'Computer Hardware', value: 'Computer Hardware' },
      { key: 'Computer Networking', value: 'Computer Networking' },
      {
        key: 'Computer Networking Products',
        value: 'Computer Networking Products',
      },
      {
        key: 'Desktop Computing Software Products',
        value: 'Desktop Computing Software Products',
      },
      {
        key: 'Digital Accessibility Services',
        value: 'Digital Accessibility Services',
      },
      {
        key: 'Embedded Software Products',
        value: 'Embedded Software Products',
      },
      { key: 'Information Services', value: 'Information Services' },
      {
        key: 'Information Technology & Services',
        value: 'Information Technology & Services',
      },
      {
        key: 'IT Services and IT Consulting',
        value: 'IT Services and IT Consulting',
      },
      {
        key: 'IT System Custom Software Development',
        value: 'IT System Custom Software Development',
      },
      { key: 'IT System Data Services', value: 'IT System Data Services' },
      { key: 'IT System Design Services', value: 'IT System Design Services' },
      {
        key: 'IT System Installation and Disposal',
        value: 'IT System Installation and Disposal',
      },
      {
        key: 'IT System Operations and Maintenance',
        value: 'IT System Operations and Maintenance',
      },
      {
        key: 'IT System Testing and Evaluation',
        value: 'IT System Testing and Evaluation',
      },
      {
        key: 'IT System Training and Support',
        value: 'IT System Training and Support',
      },
      {
        key: 'Mobile Computing Software Products',
        value: 'Mobile Computing Software Products',
      },
      { key: 'Semiconductors', value: 'Semiconductors' },
      { key: 'Software Development', value: 'Software Development' },
    ],
  },
  {
    key: 'Telecommunications Services',
    value: 'Telecommunications Services',
    children: [
      {
        key: 'Communications Equipment Manufacturing',
        value: 'Communications Equipment Manufacturing',
      },
      {
        key: 'Media and Telecommunications',
        value: 'Media and Telecommunications',
      },
      {
        key: 'Satellite Telecommunications',
        value: 'Satellite Telecommunications',
      },
      { key: 'Telecommunications', value: 'Telecommunications' },
      {
        key: 'Telecommunications Carriers',
        value: 'Telecommunications Carriers',
      },
      { key: 'Telephone Call Centers', value: 'Telephone Call Centers' },
      { key: 'Wireless Services', value: 'Wireless Services' },
    ],
  },
  {
    key: 'Transportation',
    value: 'Transportation',
    children: [
      { key: 'Airlines and Aviation', value: 'Airlines and Aviation' },
      { key: 'Aviation & Aerospace', value: 'Aviation & Aerospace' },
      {
        key: 'Aviation and Aerospace Component Manufacturing',
        value: 'Aviation and Aerospace Component Manufacturing',
      },
      {
        key: 'Ground Passenger Transportation',
        value: 'Ground Passenger Transportation',
      },
      {
        key: 'Interurban and Rural Bus Services',
        value: 'Interurban and Rural Bus Services',
      },
      { key: 'Maritime', value: 'Maritime' },
      {
        key: 'Maritime Transportation',
        value: 'Maritime Transportation',
      },
      { key: 'Rail Transportation', value: 'Rail Transportation' },
      {
        key: 'School and Employee Bus Services',
        value: 'School and Employee Bus Services',
      },
      {
        key: 'Shuttles and Special Needs Transportation Services',
        value: 'Shuttles and Special Needs Transportation Services',
      },
      {
        key: 'Sightseeing Transportation',
        value: 'Sightseeing Transportation',
      },
      {
        key: 'Taxi and Limousine Services',
        value: 'Taxi and Limousine Services',
      },
      { key: 'Truck Transportation', value: 'Truck Transportation' },
      { key: 'Urban Transit Services', value: 'Urban Transit Services' },
    ],
  },
];

export const CONTACT_METHOD_DATA = [
  { key: 'Work Email', value: 'Work Email' },
  { key: 'Personal Email', value: 'Personal Email' },
  { key: 'Mobile', value: 'Mobile' },
  { key: 'Phone', value: 'Phone' },
];

export const MAJOR_DATA = [
  { key: 'Computer Science', value: 'Computer Science' },
  { key: 'Business Administration', value: 'Business Administration' },
  { key: 'Management', value: 'Management' },
  { key: 'Accounting', value: 'Accounting' },
  { key: 'Marketing', value: 'Marketing' },
];

export const DEGREE_DATA = [
  { key: 'High School', value: 'High School' },
  { key: 'Diploma', value: 'Diploma' },
  { key: 'Associate', value: 'Associate' },
  {
    key: 'Bachelor',
    value: 'Bachelor',
    children: [
      { key: 'BTech', value: 'BTech' },
      { key: 'BE', value: 'BE' },
      { key: 'BSc', value: 'BSc' },
      { key: 'BA', value: 'BA' },
      { key: 'BBA', value: 'BBA' },
      { key: 'BCom', value: 'BCom' },
      { key: 'LLB', value: 'LLB' },
    ],
  },
  {
    key: 'Master',
    value: 'Master',
    children: [
      { key: 'MTech', value: 'MTech' },
      { key: 'ME', value: 'ME' },
      { key: 'MSc', value: 'MSc' },
      { key: 'MA', value: 'MA' },
      { key: 'MCA', value: 'MCA' },
      { key: 'MCom', value: 'MCom' },
      { key: 'LLM', value: 'LLM' },
    ],
  },
  { key: 'MBA', value: 'MBA' },
  { key: 'Doctor', value: 'Doctor' },
  { key: 'Engineering', value: 'Engineering' },
  { key: 'Law', value: 'Law' },
  { key: 'Accounting', value: 'Accounting' },
  { key: 'Economics', value: 'Economics' },
  { key: 'Psychology', value: 'Psychology' },
  { key: 'Marketing', value: 'Marketing' },
  { key: 'Business', value: 'Business' },
];

export const MANAGEMENT_LEVELS_DATA = [
  { key: 'Specialist', value: 'Specialist' },
  { key: 'Manager', value: 'Manager' },
  { key: 'Senior', value: 'Senior' },
  { key: 'Director', value: 'Director' },
  { key: 'Owner', value: 'Owner' },
  { key: 'C-Level', value: 'C-Level' },
  { key: 'Intern', value: 'Intern' },
  {
    key: 'Head',
    value: 'Head',
  },
  { key: 'President/Vice President', value: 'President/Vice President' },
  { key: 'Founder', value: 'Founder' },
  { key: 'Partner', value: 'Partner' },
];

export const REVENUE_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '<10000000', label: '< $10M' },
  { key: '10000000-50000000', label: '$10M - $50M' },
  { key: '50000000-100000000', label: '$50M - $100M' },
  { key: '100000000-500000000', label: '$100M - $500M' },
  { key: '500000000-1000000000', label: '$500M - $1B' },
  { key: '1000000000-5000000000', label: '$1B - $5B' },
  { key: '5000000000+', label: '$5B+' },
];

export const YEARS_OF_EXPERIENCE_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '1-3', label: 'Last 1-3 Years' },
  { key: '3-5', label: 'Last 3-5 Years' },
  { key: '5-10', label: 'Last 5-10 Years' },
  { key: '10-20', label: 'Last 10-20 Years' },
  { key: '20+', label: 'Last 20 Years' },
];

export const YEARS_OF_EXPERIENCE_DATA_V2 = [
  { key: 'custom', label: 'Custom' },
  { key: '0-3', label: '0 - 3 Years' },
  { key: '3-10', label: '3 - 10 Years' },
  { key: '10+', label: '10+ Years' },
];

export const EMPLOYEE_COUNT_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '1-10', label: '1 - 10' },
  { key: '11-50', label: '11 - 50' },
  { key: '51-100', label: '51 - 100' },
  { key: '101-500', label: '101 - 500' },
  { key: '501-1000', label: '501 - 1,000' },
  { key: '1001-5000', label: '1,001 - 5,000' },
  { key: '5001-10000', label: '5,001 - 10,000' },
  { key: '10001-25000', label: '10,001 - 25,000' },
  { key: '25001+', label: '25,001 +' },
];

export const CHANGE_JOB_DATA = [
  { key: '0-3', label: 'Last 3 Months' },
  { key: '0-6', label: 'Last 6 Months' },
  { key: '0-12', label: 'Last 1 Year' },
  { key: '0-24', label: 'Last 2 Years' },
  { key: '0-36', label: 'Last 3 Years' },
];

export const PROJECTED_BASE_SALARY_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '<50000', label: '< $50K' },
  { key: '50000-100000', label: '$50K - $100K' },
  { key: '100000-150000', label: '$100K - $150K' },
  { key: '150000-250000', label: '$150K - $250K' },
  { key: '250000+', label: '$250K+' },
];

export const LINKEDIN_CONNECTION_COUNT_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '0-100', label: '0 - 100' },
  { key: '101-500', label: '101 - 500' },
  { key: '501-1000', label: '501 - 1,000' },
  { key: '1001-5000', label: '1,001 - 5,000' },
  { key: '5001-10000', label: '5,001 - 10,000' },
  { key: '10001-25000', label: '10,001 - 25,000' },
  { key: '25001+', label: '25,001 +' },
];

const parseDateToString = (startDate: DateTime, endDate: DateTime) =>
  `${startDate.toISO()} - ${endDate.toISO()}`;

export const LATEST_FUNDING_DATE_RANGE_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: 'all time', label: 'All Time' },
  {
    key: parseDateToString(
      getCurrentTimeInUTC(),
      getCurrentTimeInUTC().minus({ days: 60 }),
    ),
    label: 'Last 60 days',
  },
  {
    key: parseDateToString(
      getCurrentTimeInUTC(),
      getCurrentTimeInUTC().minus({ days: 90 }),
    ),
    label: 'Last 90 days',
  },
  {
    key: parseDateToString(
      getCurrentTimeInUTC(),
      getCurrentTimeInUTC().minus({ days: 180 }),
    ),
    label: 'Last 180 days',
  },
  {
    key: parseDateToString(
      getCurrentTimeInUTC(),
      getCurrentTimeInUTC().minus({ years: 1 }),
    ),
    label: 'Last 1 year',
  },
];

// ========================
// Company Filter Data
// ========================

export const COMPANY_LIST_OPTIONS = [
  { value: '1', label: 'High Intent Accounts' },
  { value: '2', label: 'ICP - SaaS' },
  { value: '3', label: 'Recently Funded' },
  { value: '4', label: 'Hiring Now' },
  { value: '5', label: 'Competitors' },
] as const;

export const COMPANY_FOUNDING_YEAR_RANGE_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '<2000', label: 'Before 2000' },
  { key: '2000-2010', label: '2000-2010' },
  { key: '2010-2015', label: '2010-2015' },
  { key: '2015-2020', label: '2015-2020' },
  { key: '2020+', label: '2020-Present' },
];

export const COMPANY_RANGE_SMALL_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '1-5', label: '1-5' },
  { key: '6-10', label: '6-10' },
  { key: '11-25', label: '11-25' },
  { key: '26-50', label: '26-50' },
  { key: '51-100', label: '51-100' },
  { key: '100+', label: '100+' },
];

export const SENIORITY_GROUP_OPTIONS = [
  { key: 'owner', label: 'Owner', paramKey: 'owner' },
  { key: 'founder', label: 'Founder', paramKey: 'founder' },
  { key: 'clevel', label: 'C-Level', paramKey: 'clevel' },
  { key: 'partner', label: 'Partner', paramKey: 'partner' },
  { key: 'vp', label: 'VP', paramKey: 'vp' },
  { key: 'head', label: 'Head', paramKey: 'head' },
  { key: 'director', label: 'Director', paramKey: 'director' },
  { key: 'manager', label: 'Manager', paramKey: 'manager' },
  { key: 'senior', label: 'Senior', paramKey: 'senior' },
  { key: 'mid', label: 'Mid', paramKey: 'mid' },
  { key: 'junior', label: 'Junior', paramKey: 'junior' },
  { key: 'intern', label: 'Intern', paramKey: 'intern' },
  { key: 'specialist', label: 'Specialist', paramKey: 'specialist' },
  {
    key: 'other_management',
    label: 'Other Management',
    paramKey: 'other_management',
  },
];

export const DEPARTMENT_GROUP_OPTIONS = [
  { key: 'medical', label: 'Medical', paramKey: 'medical' },
  { key: 'sales', label: 'Sales', paramKey: 'sales' },
  { key: 'hr', label: 'HR', paramKey: 'hr' },
  { key: 'legal', label: 'Legal', paramKey: 'legal' },
  { key: 'marketing', label: 'Marketing', paramKey: 'marketing' },
  { key: 'finance', label: 'Finance', paramKey: 'finance' },
  { key: 'technical', label: 'Technical', paramKey: 'technical' },
  { key: 'consulting', label: 'Consulting', paramKey: 'consulting' },
  { key: 'operations', label: 'Operations', paramKey: 'operations' },
  { key: 'product', label: 'Product', paramKey: 'product' },
  {
    key: 'general_management',
    label: 'General Management',
    paramKey: 'general_management',
  },
  {
    key: 'administrative',
    label: 'Administrative',
    paramKey: 'administrative',
  },
  {
    key: 'customer_service',
    label: 'Customer Service',
    paramKey: 'customer_service',
  },
  {
    key: 'project_management',
    label: 'Project Management',
    paramKey: 'project_management',
  },
  { key: 'design', label: 'Design', paramKey: 'design' },
  { key: 'research', label: 'Research', paramKey: 'research' },
  { key: 'trades', label: 'Trades', paramKey: 'trades' },
  { key: 'real_estate', label: 'Real Estate', paramKey: 'real_estate' },
  { key: 'education', label: 'Education', paramKey: 'education' },
  {
    key: 'other_department',
    label: 'Other Department',
    paramKey: 'other_department',
  },
];

export const COMPANY_JOB_OPENING_RANGE_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '1-5', label: '1-5' },
  { key: '6-10', label: '6-10' },
  { key: '11-25', label: '11-25' },
  { key: '26-50', label: '26-50' },
  { key: '50+', label: '50+' },
];

export const COMPANY_LINKEDIN_FOLLOWERS_RANGE_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '0-500', label: '0-500' },
  { key: '500-1000', label: '500-1,000' },
  { key: '1000-5000', label: '1,000-5,000' },
  { key: '5000+', label: '5,000+' },
];

export const COMPANY_WEBSITE_VISITORS_RANGE_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '0-1000', label: '0-1,000' },
  { key: '1000-10000', label: '1,000-10,000' },
  { key: '10000-50000', label: '10,000-50,000' },
  { key: '50000+', label: '50,000+' },
];

export const COMPANY_REVENUE_RANGE_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '0-1000000', label: '< $1M' },
  { key: '1000000-10000000', label: '$1M-$10M' },
  { key: '10000000-50000000', label: '$10M-$50M' },
  { key: '50000000-100000000', label: '$50M-$100M' },
  { key: '100000000+', label: '$100M+' },
];

export const COMPANY_FUNDING_AMOUNT_RANGE_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '0-1000000', label: '< $1M' },
  { key: '1000000-5000000', label: '$1M-$5M' },
  { key: '5000000-10000000', label: '$5M-$10M' },
  { key: '10000000-50000000', label: '$10M-$50M' },
  { key: '50000000+', label: '$50M+' },
];

export const COMPANY_FUNDING_ROUND_DATA = [
  { key: 'Series rounds', value: 'Series rounds' },
  { key: 'Pre-Series rounds', value: 'Pre-Series rounds' },
  { key: 'Seed', value: 'Seed' },
  { key: 'Pre-Seed', value: 'Pre-Seed' },
  { key: 'Angel investments', value: 'Angel investments' },
  { key: 'Venture rounds', value: 'Venture rounds' },
  { key: 'Private Equity', value: 'Private Equity' },
  { key: 'Growth Equity', value: 'Growth Equity' },
  { key: 'Bridge financing', value: 'Bridge financing' },
  { key: 'Convertible notes', value: 'Convertible notes' },
  { key: 'IPO and Post-IPO', value: 'IPO and Post-IPO' },
  { key: 'SAFE agreements', value: 'SAFE agreements' },
  { key: 'Debt financing', value: 'Debt financing' },
  { key: 'Mezzanine', value: 'Mezzanine' },
  { key: 'Corporate Round', value: 'Corporate Round' },
  { key: 'Grants', value: 'Grants' },
  { key: 'Crowdfunding', value: 'Crowdfunding' },
  { key: 'Other', value: 'Other' },
];

export const COMPANY_FUNDING_DATE_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: 'last_30_days', label: 'Last 30 days' },
  { key: 'last_90_days', label: 'Last 90 days' },
  { key: 'last_6_months', label: 'Last 6 months' },
  { key: 'last_year', label: 'Last year' },
];

export const COMPANY_TECHNOLOGIES_DATA = [
  { key: 'React', value: 'React' },
  { key: 'Node.js', value: 'Node.js' },
  { key: 'Python', value: 'Python' },
  { key: 'AWS', value: 'AWS' },
  { key: 'Google Cloud', value: 'Google Cloud' },
  { key: 'Azure', value: 'Azure' },
  { key: 'Salesforce', value: 'Salesforce' },
  { key: 'HubSpot', value: 'HubSpot' },
  { key: 'Kubernetes', value: 'Kubernetes' },
  { key: 'Docker', value: 'Docker' },
];

export const COMPANY_REVIEW_SCORE_BUCKET_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '0-1', label: '0-1' },
  { key: '1-2', label: '1-2' },
  { key: '2-3', label: '2-3' },
  { key: '3-4', label: '3-4' },
  { key: '4-5', label: '4-5' },
];

export const COMPANY_REVIEW_COUNT_BUCKET_DATA = [
  { key: 'custom', label: 'Custom' },
  { key: '1-10', label: '1-10' },
  { key: '11-50', label: '11-50' },
  { key: '51-100', label: '51-100' },
  { key: '100+', label: '100+' },
];

export const COMPANY_TYPE_DATA = [
  { key: 'Public Company', value: 'Public Company' },
  { key: 'Privately Held', value: 'Privately Held' },
  { key: 'Non-Profit', value: 'Non-Profit' },
  { key: 'Educational Institution', value: 'Educational Institution' },
  { key: 'Partnership', value: 'Partnership' },
  { key: 'Self Employment', value: 'Self Employment' },
  { key: 'Self owned', value: 'Self owned' },
  { key: 'Government Agency', value: 'Government Agency' },
  { key: 'Solo Proprietorship', value: 'Solo Proprietorship' },
];

export const COMPANY_CURRENCY_DATA = [
  { key: 'USD', value: 'USD' },
  { key: 'EUR', value: 'EUR' },
  { key: 'GBP', value: 'GBP' },
  { key: 'INR', value: 'INR' },
  { key: 'JPY', value: 'JPY' },
  { key: 'CAD', value: 'CAD' },
  { key: 'AUD', value: 'AUD' },
];

export const COMPANY_PERCENTAGE_RANGE_DATA = [
  { key: '0-10', label: '0-10%' },
  { key: '10-25', label: '10-25%' },
  { key: '25-50', label: '25-50%' },
  { key: '50-75', label: '50-75%' },
  { key: '75-100', label: '75-100%' },
  { key: 'custom', label: 'Custom' },
];

export const SCORE_CHANGE_DURATION_DATA = [
  { key: 'current', label: 'Current' },
  { key: 'monthly', label: 'Monthly' },
  { key: 'quarterly', label: 'Quarterly' },
  { key: 'yearly', label: 'Yearly' },
];

export const SCORE_CHANGE_DIRECTION_DATA = [
  { key: 'up', label: 'Up' },
  { key: 'down', label: 'Down' },
  { key: 'any', label: 'Any' },
];

export const SCORE_CHANGE_RANGE_DATA = [
  { key: '0-0.5', label: '0-0.5' },
  { key: '0.5-1.0', label: '0.5-1.0' },
  { key: '1.0-1.5', label: '1.0-1.5' },
  { key: '1.5-2.0', label: '1.5-2.0' },
  { key: '2.0+', label: '2.0+' },
];

// Flattened country list for dropdown (LOCATION_DATA has nested structure)
export const FLATTENED_COUNTRY_LIST = (() => {
  const result: Array<{ key: string; label: string }> = [
    { key: 'select', label: 'Select' },
  ];
  LOCATION_DATA.forEach((region) => {
    if (region.children) {
      region.children.forEach((c) => {
        result.push({
          key: c.value,
          label: c.key || c.value,
        });
      });
    } else {
      result.push({
        key: region.value,
        label: region.key || region.value,
      });
    }
  });
  return result;
})();

// Country name to ISO 3166-1 alpha-2 code mapping for API payload
export const COUNTRY_NAME_TO_CODE: Record<string, string> = {
  'United States': 'US',
  Canada: 'CA',
  'United Kingdom': 'GB',
  Australia: 'AU',
  Germany: 'DE',
  France: 'FR',
  India: 'IN',
  Japan: 'JP',
  Brazil: 'BR',
  China: 'CN',
  Mexico: 'MX',
  Italy: 'IT',
  Spain: 'ES',
  Netherlands: 'NL',
  'South Korea': 'KR',
  Argentina: 'AR',
  Russia: 'RU',
  'South Africa': 'ZA',
  Indonesia: 'ID',
  Turkey: 'TR',
  'Saudi Arabia': 'SA',
  Singapore: 'SG',
  Sweden: 'SE',
  Poland: 'PL',
  Belgium: 'BE',
  Switzerland: 'CH',
  Austria: 'AT',
  Norway: 'NO',
  Thailand: 'TH',
  'United Arab Emirates': 'AE',
  Israel: 'IL',
  Ireland: 'IE',
  Malaysia: 'MY',
  Philippines: 'PH',
  Vietnam: 'VN',
  Denmark: 'DK',
  Colombia: 'CO',
  Chile: 'CL',
  Egypt: 'EG',
  Pakistan: 'PK',
  Bangladesh: 'BD',
  Nigeria: 'NG',
  Iran: 'IR',
  Ukraine: 'UA',
  'Hong Kong': 'HK',
  'New Zealand': 'NZ',
  Portugal: 'PT',
  Romania: 'RO',
  'Czech Republic': 'CZ',
  Greece: 'GR',
  Hungary: 'HU',
  Finland: 'FI',
  Peru: 'PE',
  Ecuador: 'EC',
  Venezuela: 'VE',
  Asia: 'AS',
};
